var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.54465862 7.54465862 4.13923883 32.72121957 4.1875 42.6875 C4.13824654 79.72869473 -5.32116043 114.32444345 -31.1875 141.6875 C-44.98932327 154.97103505 -62.73222066 162.8840958 -79.69140625 171.33984375 C-87.09441501 175.07601971 -94.0002051 179.14225807 -100.6875 184.0625 C-101.33517334 184.53300781 -101.98284668 185.00351562 -102.65014648 185.48828125 C-110.39418994 191.40320703 -117.03221798 199.83533258 -118.36816406 209.72558594 C-118.54074164 212.61404145 -118.60946483 215.48157462 -118.625 218.375 C-118.65049725 220.32043998 -118.68398759 222.26579632 -118.7265625 224.2109375 C-118.73252441 225.05962402 -118.73848633 225.90831055 -118.74462891 226.78271484 C-119 229 -119 229 -121 232 C-124.08470658 232.8717649 -126.16072301 233.25644575 -129.25 232.3125 C-132.13496582 230.14877564 -132.80897737 227.93356922 -133.51953125 224.4609375 C-134.24137473 219.26131699 -134.38975028 214.05365987 -134.60546875 208.8125 C-134.64285156 207.99523437 -134.68023437 207.17796875 -134.71875 206.3359375 C-134.76418945 205.23064697 -134.76418945 205.23064697 -134.81054688 204.10302734 C-134.94171241 201.99609096 -134.94171241 201.99609096 -135.52636719 199.99365234 C-136.04750592 197.80003436 -135.98800749 196.01112293 -135.859375 193.765625 C-135.80660037 188.80074999 -137.18255345 185.20038177 -139.25 180.75 C-139.89626719 179.27272443 -140.53816125 177.79352841 -141.17578125 176.3125 C-141.64491943 175.22582031 -141.64491943 175.22582031 -142.12353516 174.1171875 C-144.78299976 167.69298777 -147.32036356 161.02236921 -147 154 C-147.99 153.67 -148.98 153.34 -150 153 C-149.34 153 -148.68 153 -148 153 C-148.30921884 151.54096742 -148.62248799 150.08279278 -148.9375 148.625 C-149.19853516 147.40683594 -149.19853516 147.40683594 -149.46484375 146.1640625 C-149.92330693 143.970537 -149.92330693 143.970537 -151 142 C-151.9440621 126.65326923 -151.8435818 110.9403744 -148 96 C-147.83371094 95.34322266 -147.66742188 94.68644531 -147.49609375 94.00976562 C-139.76352344 64.31096779 -119.53877909 39.00232378 -93.28027344 23.29882812 C-79.51064356 15.4557413 -65.33047076 9.55930099 -50.01660156 5.54492188 C-48.358339 5.09682962 -46.71856416 4.58087085 -45.0859375 4.046875 C-31.54800072 -0.33683786 -14.17335578 -1.3927575 0 0 Z M-81 34 C-82.11503906 34.61488281 -83.23007813 35.22976563 -84.37890625 35.86328125 C-95.89510709 42.55681314 -106.86924443 51.370731 -115 62 C-115.556875 62.70898438 -116.11375 63.41796875 -116.6875 64.1484375 C-125.11001096 75.4661866 -130.93323528 88.24798138 -134 102 C-134.33644531 103.46179688 -134.33644531 103.46179688 -134.6796875 104.953125 C-136.71552134 115.60639251 -136.77822152 127.18599072 -136 138 C-135.67 138.33 -135.34 138.66 -135 139 C-135 141.33333333 -135 143.66666667 -135 146 C-134.71479595 147.67557379 -134.40044304 149.34817245 -134 151 C-131.86558357 150.20774462 -131.86558357 150.20774462 -131.30493164 148.29199219 C-131.09215576 147.55110352 -130.87937988 146.81021484 -130.66015625 146.046875 C-122.00729514 117.35784554 -106.27954792 92.14291748 -83 73 C-82.20464844 72.30519531 -81.40929687 71.61039063 -80.58984375 70.89453125 C-75.41131012 66.46341484 -70.0799168 62.63031601 -64.25 59.125 C-63.63632568 58.75584473 -63.02265137 58.38668945 -62.39038086 58.00634766 C-51.80374849 51.80811186 -51.80374849 51.80811186 -47.0625 52.3125 C-46.381875 52.539375 -45.70125 52.76625 -45 53 C-45.26292436 56.42996779 -45.68408312 57.71131734 -48.265625 60.0703125 C-49.25046875 60.74835938 -50.2353125 61.42640625 -51.25 62.125 C-52.34381933 62.89988569 -53.4348663 63.67869629 -54.5234375 64.4609375 C-55.09288086 64.86924805 -55.66232422 65.27755859 -56.24902344 65.69824219 C-59.23452737 67.91780534 -62.05209643 70.32907658 -64.875 72.75 C-65.39739258 73.19746582 -65.91978516 73.64493164 -66.45800781 74.10595703 C-66.96428711 74.54020996 -67.47056641 74.97446289 -67.9921875 75.421875 C-70.03704142 77.17460693 -72.09117317 78.89465058 -74.17578125 80.59765625 C-76.46435531 82.54436863 -78.39071098 84.39823711 -80.3125 86.6875 C-82.17092179 88.88271002 -84.02997849 91.03119383 -86.0234375 93.10546875 C-109.35244154 117.57144591 -122.7685531 150.35445308 -122 184 C-121.27425781 183.26136719 -120.54851562 182.52273438 -119.80078125 181.76171875 C-108.26052777 170.3824172 -94.65021954 162.10410203 -80.15722656 155.04101562 C-68.53782572 149.37052074 -56.8031479 143.53001181 -47 135 C-46.40445313 134.52304687 -45.80890625 134.04609375 -45.1953125 133.5546875 C-35.75264549 125.87465167 -29.58265632 116.67201757 -24 106 C-23.525625 105.09378906 -23.05125 104.18757813 -22.5625 103.25390625 C-13.32110776 84.2801728 -10.80435008 63.41599999 -10.875 42.5625 C-10.87113281 41.42490234 -10.86726563 40.28730469 -10.86328125 39.11523438 C-9.92636363 26.84472636 -9.92636363 26.84472636 -13 16 C-36.14396752 13.75049288 -61.17423861 22.81553599 -81 34 Z ",
    fill: "#14384C",
    transform: "translate(313,390)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 1.485 0.495 1.485 1 3 C4.96 3.33 8.92 3.66 13 4 C13.33 3.34 13.66 2.68 14 2 C15.15746602 5.66554103 15.10718502 9.09769646 15.08178711 12.92407227 C15.07872055 13.612341 15.07565399 14.30060974 15.07249451 15.00973511 C15.06535643 16.49988031 15.05597534 17.99001609 15.04459953 19.48013496 C15.0271855 21.83783213 15.01690311 24.19546132 15.00868225 26.5532074 C14.98424472 33.25518214 14.9485797 39.95706487 14.90405273 46.65893555 C14.87729422 50.76135086 14.86023677 54.86371365 14.84918404 58.96619987 C14.84297095 60.52953984 14.8329615 62.09286945 14.81910515 63.65616035 C14.79992128 65.83928256 14.79299778 68.02212723 14.78881836 70.20532227 C14.78136093 71.44790298 14.7739035 72.6904837 14.76622009 73.97071838 C14.76534803 77.17780881 14.76534803 77.17780881 17 80 C15.625 83.6875 15.625 83.6875 14 87 C8.95386773 87.9806249 3.91617027 88.81327162 -1 87 C-5.37229124 83.2721253 -8.0516596 78.03322359 -10.80566406 73.06982422 C-13.113848 69.06966407 -15.72846951 65.27153049 -19 62 C-19.97835191 60.47095899 -20.93280172 58.92658025 -21.875 57.375 C-26.86928959 49.65655245 -32.48400054 42.35466594 -38 35 C-38.33 52.16 -38.66 69.32 -39 87 C-44.28 87 -49.56 87 -55 87 C-55 59.61 -55 32.22 -55 4 C-42 3 -42 3 -39 4 C-37.5625 5.9765625 -37.5625 5.9765625 -36 8.625 C-33.09160104 13.35803662 -29.99461159 17.85591625 -26.6875 22.3125 C-22.2796469 28.25743121 -17.95176225 34.24973134 -13.6796875 40.29296875 C-9.88524311 45.60046753 -5.92586679 50.78950769 -2 56 C-2.00666183 55.05825676 -2.00666183 55.05825676 -2.01345825 54.0974884 C-2.05772275 47.56005124 -2.08787946 41.02265669 -2.10986328 34.48510742 C-2.1199176 32.0456367 -2.13356292 29.60617803 -2.15087891 27.16674805 C-2.17515182 23.65931221 -2.18648891 20.15203579 -2.1953125 16.64453125 C-2.20563507 15.55477493 -2.21595764 14.46501862 -2.22659302 13.34223938 C-2.22681961 11.81121834 -2.22681961 11.81121834 -2.22705078 10.24926758 C-2.231492 9.35436111 -2.23593323 8.45945465 -2.24050903 7.53742981 C-1.97350263 4.72044624 -1.16460699 2.56584518 0 0 Z ",
    fill: "#11364A",
    transform: "translate(783,401)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.96803246 5.50173786 11.94171049 11.09788343 16 19 C13.75539393 21.49560036 11.61479403 22.8705484 8.5625 24.25 C7.80066406 24.60578125 7.03882813 24.9615625 6.25390625 25.328125 C3.66498359 26.09986624 2.47220094 26.05424347 0 25 C-1.3540932 23.01399663 -2.68457624 21.01182457 -4 19 C-8.94305312 14.05694688 -13.58545708 12.11950196 -20.453125 11.93359375 C-27.47481334 12.28898595 -32.70178602 14.47519117 -37.53515625 19.640625 C-43.57982759 27.46521414 -43.86069472 36.43672533 -43 46 C-41.15998033 53.5192155 -37.86682771 58.2932206 -31.5 62.75 C-25.46109962 65.76945019 -17.98205576 66.08545134 -11.4921875 64.31640625 C-6.35279111 62.27252089 -3.46447947 60.13433222 -1 55 C-0.20929452 51.76961158 -0.20929452 51.76961158 0 49 C-1.27230469 49.24556641 -1.27230469 49.24556641 -2.5703125 49.49609375 C-6.0645531 50.00948445 -9.34627574 50.09850739 -12.875 50.0625 C-14.02742188 50.05347656 -15.17984375 50.04445313 -16.3671875 50.03515625 C-17.23601562 50.02355469 -18.10484375 50.01195312 -19 50 C-20.37252731 47.25494537 -20.13229255 44.99672588 -20.125 41.9375 C-20.12757813 40.85339844 -20.13015625 39.76929688 -20.1328125 38.65234375 C-20 36 -20 36 -19 35 C-16.26105915 34.91141354 -13.5474673 34.88476521 -10.80859375 34.90234375 C-9.98875504 34.9037587 -9.16891632 34.90517365 -8.32423401 34.90663147 C-5.69528618 34.91224711 -3.06642227 34.92480221 -0.4375 34.9375 C1.34049357 34.94251299 3.11848846 34.94707624 4.89648438 34.95117188 C9.26435545 34.96222161 13.63216348 34.97949669 18 35 C18.02897673 37.03897675 18.04942554 39.07807556 18.06640625 41.1171875 C18.08489624 42.82044189 18.08489624 42.82044189 18.10375977 44.55810547 C17.80114207 54.59646833 14.46460923 63.30225721 8 71 C5.17918644 73.40382373 2.26119117 75.25314623 -1 77 C-2.0725 77.598125 -3.145 78.19625 -4.25 78.8125 C-13.15072282 82.65599395 -25.91425583 82.46718351 -35.0625 79.375 C-46.79887911 74.30701811 -54.10711068 65.61368823 -59 54 C-63.04405169 42.44556661 -61.74609337 30.14236689 -57 19 C-51.9123794 9.59138655 -44.31290191 1.64131767 -34.1015625 -2.046875 C-22.95993811 -5.08289604 -10.60315389 -5.30157694 0 0 Z ",
    fill: "#15394D",
    transform: "translate(424,521)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C44.95597484 0 44.95597484 0 54.1875 7.86328125 C60.64397662 14.79054262 62.58198811 21.38906385 62.35546875 30.7734375 C61.62444812 37.40885552 58.72808392 43.27191608 54 48 C51.72046585 49.49671357 49.42692227 50.73986728 47 52 C51.05225338 59.92330843 55.73634456 67.27075844 60.73046875 74.6171875 C62.58801209 77.35550893 64.3314862 80.14124346 66 83 C63.85552692 85.14447308 59.21113967 84.23155053 56.25 84.25 C55.43789063 84.270625 54.62578125 84.29125 53.7890625 84.3125 C48.99824786 84.34371052 45.93983369 84.04296098 42 81 C42.495 79.515 42.495 79.515 43 78 C41.95603769 75.6350745 41.95603769 75.6350745 40.32421875 73.1484375 C39.74349609 72.21515625 39.16277344 71.281875 38.56445312 70.3203125 C37.94505859 69.34835937 37.32566406 68.37640625 36.6875 67.375 C35.77581055 65.90546875 35.77581055 65.90546875 34.84570312 64.40625 C32.13480314 59.47309884 32.13480314 59.47309884 28 56 C26.45976004 55.93049459 24.91665012 55.91547643 23.375 55.9375 C22.14910156 55.95103516 22.14910156 55.95103516 20.8984375 55.96484375 C20.27195312 55.97644531 19.64546875 55.98804688 19 56 C17.87483915 57.83284443 17.87483915 57.83284443 17 60 C17.33 60.99 17.66 61.98 18 63 C17.34 63 16.68 63 16 63 C16.16242188 63.49113281 16.32484375 63.98226562 16.4921875 64.48828125 C17.21165244 68.04686554 17.14427424 71.5735794 17.125 75.1875 C17.13080078 76.29254883 17.13080078 76.29254883 17.13671875 77.41992188 C17.12668491 82.87331509 17.12668491 82.87331509 16 84 C13.34177343 84.12658222 10.72112576 84.18520214 8.0625 84.1875 C7.32064453 84.19974609 6.57878906 84.21199219 5.81445312 84.22460938 C3.87486371 84.22988478 1.9357629 84.12188902 0 84 C-0.66 83.34 -1.32 82.68 -2 82 C-1.34 82 -0.68 82 0 82 C0 54.94 0 27.88 0 0 Z M16 16 C15.913015 19.77068832 15.85961421 23.54111932 15.8125 27.3125 C15.78736328 28.38435547 15.76222656 29.45621094 15.73632812 30.56054688 C15.72666016 31.58857422 15.71699219 32.61660156 15.70703125 33.67578125 C15.6913208 34.62364502 15.67561035 35.57150879 15.65942383 36.5480957 C15.80475251 39.04269896 15.80475251 39.04269896 17.35351562 40.81005859 C21.50982791 43.81389401 28.54137353 42.28925017 33.390625 41.71875 C38.26131468 40.75204823 40.87873103 38.78335633 44 35 C45.60105604 31.79788792 45.35668408 28.48253365 45 25 C43.7971671 21.64472928 42.76986364 19.65810924 40.0625 17.34375 C35.47451084 15.33065271 31.13502518 15.68291405 26.1875 15.8125 C25.20845703 15.82603516 24.22941406 15.83957031 23.22070312 15.85351562 C20.81323375 15.88874688 18.40690436 15.93800735 16 16 Z ",
    fill: "#14384C",
    transform: "translate(446,404)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2.61669922 2.68701172 C3.08147679 5.49166313 3.12977386 8.16407992 3.1328125 11.0078125 C3.13410156 12.15894531 3.13539063 13.31007813 3.13671875 14.49609375 C3.13285156 15.69363281 3.12898437 16.89117187 3.125 18.125 C3.13080078 19.93291016 3.13080078 19.93291016 3.13671875 21.77734375 C3.13542969 22.92589844 3.13414062 24.07445312 3.1328125 25.2578125 C3.13168457 26.3111377 3.13055664 27.36446289 3.12939453 28.44970703 C3 31 3 31 2 33 C2.66 33 3.32 33 4 33 C4 33.99 4 34.98 4 36 C5.16789063 35.89171875 5.16789063 35.89171875 6.359375 35.78125 C16.91923913 34.90531657 27.41088658 34.90412272 38 35 C37.01 34.505 37.01 34.505 36 34 C35.97287649 31.60408962 35.9531018 29.20849043 35.9375 26.8125 C35.92912109 26.13896484 35.92074219 25.46542969 35.91210938 24.77148438 C35.89381627 21.02139783 36.26792957 17.66035217 37 14 C36.9120852 11.32530548 36.9120852 11.32530548 36.5625 8.6875 C36.40974609 7.36298828 36.40974609 7.36298828 36.25390625 6.01171875 C36.17011719 5.34785156 36.08632813 4.68398438 36 4 C39 2 39 2 54 3 C54 30.39 54 57.78 54 86 C48.06 86 42.12 86 36 86 C35.97706784 81.19443933 35.95714752 76.38906785 35.94506836 71.58349609 C35.94003379 69.94807289 35.93320573 68.3126542 35.92456055 66.67724609 C35.91245665 64.32909025 35.906763 61.98099381 35.90234375 59.6328125 C35.89718246 58.89942657 35.89202118 58.16604065 35.88670349 57.41043091 C35.88612829 52.22774341 35.88612829 52.22774341 37 50 C25.45 50 13.9 50 2 50 C2.33 51.32 2.66 52.64 3 54 C3.06980944 56.05100138 3.08444729 58.10417828 3.0625 60.15625 C3.05476562 61.34347656 3.04703125 62.53070313 3.0390625 63.75390625 C3.01302083 66.25130208 2.98697917 68.74869792 2.9609375 71.24609375 C2.95320312 72.43332031 2.94546875 73.62054688 2.9375 74.84375 C2.92589844 75.92849609 2.91429687 77.01324219 2.90234375 78.13085938 C2.9871049 80.62114209 3.38266829 82.61131559 4 85 C1.89868615 87.10131385 -2.54146322 86.18514741 -5.4375 86.1875 C-6.22705078 86.19974609 -7.01660156 86.21199219 -7.83007812 86.22460938 C-9.88807435 86.22987279 -11.94562009 86.12206285 -14 86 C-14.66 85.34 -15.32 84.68 -16 84 C-15.34 84 -14.68 84 -14 84 C-14 56.94 -14 29.88 -14 2 C-7.07 2.495 -7.07 2.495 0 3 C0 2.01 0 1.02 0 0 Z M37 7 C38 10 38 10 38 10 Z M37 19 C38 22 38 22 38 22 Z M37 23 C38 26 38 26 38 26 Z M37 27 C38 30 38 30 38 30 Z M37 59 C38 62 38 62 38 62 Z M37 71 C38 73 38 73 38 73 Z ",
    fill: "#103448",
    transform: "translate(652,402)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.66 2.33 2.32 2.66 3 3 C2.34 3 1.68 3 1 3 C1.06728017 10.09872232 1.15719564 17.196906 1.26245117 24.29516602 C1.29559475 26.70721014 1.32365918 29.11932985 1.34643555 31.53149414 C1.38017572 35.00960335 1.43250262 38.48702644 1.48828125 41.96484375 C1.49467117 43.03395493 1.5010611 44.1030661 1.50764465 45.20457458 C1.63708642 51.87723004 1.88725885 59.24908283 6.34516907 64.62095642 C11.12234758 68.92727368 15.70264083 69.32085138 21.9453125 69.21484375 C26.7404984 68.71344598 30.09446164 66.95319827 33.375 63.5 C35.81398839 59.74771016 36.13643595 56.89800023 36.20532227 52.51879883 C36.22526749 51.39786331 36.24521271 50.2769278 36.26576233 49.12202454 C36.29083107 47.30785286 36.29083107 47.30785286 36.31640625 45.45703125 C36.33718735 44.21829758 36.35796844 42.9795639 36.37937927 41.70329285 C36.43371797 38.41374744 36.48395951 35.12417274 36.53222656 31.83453369 C36.58250646 28.47622186 36.63815861 25.11799954 36.69335938 21.75976562 C36.80053048 15.17324841 36.90230135 8.58666416 37 2 C48.52164009 0.66742597 48.52164009 0.66742597 54 2 C54.07642165 9.64967407 54.12875549 17.29924869 54.16479492 24.94921875 C54.17982831 27.54854003 54.20026046 30.14783617 54.22631836 32.74707031 C54.26294101 36.49550605 54.27978152 40.24360472 54.29296875 43.9921875 C54.30845261 45.14363251 54.32393646 46.29507751 54.33988953 47.48141479 C54.34210959 58.26252612 52.27556533 67.74381499 45 76 C37.36017384 82.47970441 29.14622177 85.57264259 19.1875 85.4375 C18.00837036 85.42614014 18.00837036 85.42614014 16.80541992 85.41455078 C7.9991842 85.16658977 0.04425114 83.06830279 -6.4375 76.8046875 C-13.36206841 68.80681098 -14.94965117 61.36428549 -16 51 C-16.19980469 50.07832031 -16.39960938 49.15664063 -16.60546875 48.20703125 C-17 46 -17 46 -16 44 C-16.165 43.29875 -16.33 42.5975 -16.5 41.875 C-17.04039837 38.76770938 -16.71171048 36.15397097 -16.26171875 33.05078125 C-15.780741 29.28192572 -15.63651548 25.55537561 -16.50390625 21.84375 C-17.18425747 17.94378397 -17.1055401 14.13725676 -17.0625 10.1875 C-17.05573242 9.00510742 -17.05573242 9.00510742 -17.04882812 7.79882812 C-17.03711312 5.86585239 -17.01917998 3.93291607 -17 2 C-13.54650314 0.92966683 -10.41297508 0.9298324 -6.8125 1 C-4.87536251 1.03747787 -2.93693264 1.04688491 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#13394D",
    transform: "translate(473,517)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.33 10.56 0.66 16 1 C16.02293351 5.66314714 16.04285342 10.32609925 16.05493164 14.98925781 C16.05996588 16.57617861 16.06679369 18.16309477 16.07543945 19.75 C16.08754482 22.02865749 16.09323733 24.30725376 16.09765625 26.5859375 C16.10281754 27.29744965 16.10797882 28.00896179 16.11329651 28.74203491 C16.11387171 33.77225659 16.11387171 33.77225659 15 36 C19.07463591 32.08352925 22.64814188 27.90195752 26.1875 23.5 C26.75049805 22.80382568 27.31349609 22.10765137 27.89355469 21.39038086 C32.40802264 15.78685174 36.81636827 10.10649422 41.171875 4.37890625 C43 2 43 2 44 1 C45.41327947 0.84379445 46.8335459 0.74943827 48.25390625 0.68359375 C49.10791016 0.64169922 49.96191406 0.59980469 50.84179688 0.55664062 C51.73962891 0.51732422 52.63746094 0.47800781 53.5625 0.4375 C54.91504883 0.37272461 54.91504883 0.37272461 56.29492188 0.30664062 C58.52978485 0.20021858 60.76476308 0.09820012 63 0 C62.1477565 4.23858155 59.93877441 6.71303597 57.125 9.875 C53.00897167 14.60989313 49.03543737 19.41955544 45.1875 24.375 C41.57124144 29.02274811 37.89332909 33.58054536 34 38 C35.60200119 43.2741208 38.98573477 47.0828164 42.375 51.3125 C43.64077526 52.91030886 44.90506818 54.50929302 46.16796875 56.109375 C46.80653809 56.91826172 47.44510742 57.72714844 48.10302734 58.56054688 C49.93493113 60.91632327 51.72056894 63.29891473 53.48828125 65.703125 C54.02855957 66.43748779 54.56883789 67.17185059 55.12548828 67.9284668 C56.14904244 69.32685488 57.16716331 70.72923985 58.17919922 72.13598633 C60.89244106 75.95367426 60.89244106 75.95367426 65 78 C65.38218767 79.65614657 65.71395102 81.32457024 66 83 C63.39138075 85.60861925 57.14034357 85.03401055 53.56640625 85.14086914 C48.84310455 84.95713623 45.80715644 84.4312421 42.45703125 80.9609375 C39.79256828 77.59702638 37.56838257 73.97440355 35.39257812 70.28076172 C33.08925453 66.50838286 30.40660923 63.02771997 27.75 59.5 C26.82591702 58.24120123 25.90382133 56.98093942 24.984375 55.71875 C24.32953125 54.8215625 23.6746875 53.924375 23 53 C20.53199953 54.15173355 18.95216435 55.04783565 17 57 C15.6573322 63.3471569 16.22001417 69.30173696 16.84375 75.73046875 C16.9874558 78.73751255 16.74273676 81.10004984 16 84 C13.39555652 84.05394705 10.79223002 84.09364469 8.1875 84.125 C7.44951172 84.14175781 6.71152344 84.15851563 5.95117188 84.17578125 C2.08753574 84.21074628 0.29096332 84.19397555 -3 82 C-2.34 82 -1.68 82 -1 82 C-0.97307516 79.70839681 -0.95363876 77.41670454 -0.9375 75.125 C-0.92589844 73.84882813 -0.91429687 72.57265625 -0.90234375 71.2578125 C-0.76823431 68.11335348 -0.76823431 68.11335348 -2 66 C-1.34 66 -0.68 66 0 66 C-0.16226074 65.10434326 -0.32452148 64.20868652 -0.49169922 63.28588867 C-1.28539406 57.69055881 -1.14270195 52.06554757 -1.1328125 46.42578125 C-1.13376923 45.22439011 -1.13472595 44.02299896 -1.13571167 42.78520203 C-1.13639023 40.25450589 -1.13455858 37.72380799 -1.13037109 35.19311523 C-1.12500423 31.31555291 -1.13033432 27.43810568 -1.13671875 23.56054688 C-1.13605819 21.09895808 -1.13477748 18.63736935 -1.1328125 16.17578125 C-1.13483673 15.01532791 -1.13686096 13.85487457 -1.13894653 12.65925598 C-1.13579437 11.58101059 -1.13264221 10.5027652 -1.12939453 9.3918457 C-1.12859894 8.44477249 -1.12780334 7.49769928 -1.12698364 6.52192688 C-1 4 -1 4 0 0 Z ",
    fill: "#14394D",
    transform: "translate(367,404)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.74958984 0.05220703 1.49917969 0.10441406 2.27148438 0.15820312 C4.11887082 0.28763784 5.96574371 0.42436518 7.8125 0.5625 C13.86792827 15.46683491 19.62571196 30.47613863 25.29345703 45.53173828 C26.63420489 49.09210897 27.98110963 52.65012618 29.32901001 56.20779419 C30.44979949 59.16792236 31.56760615 62.12917081 32.68469238 65.09069824 C33.22635443 66.5252633 33.76907196 67.9594303 34.31286621 69.39318848 C35.06977692 71.38986873 35.8225121 73.38807454 36.57421875 75.38671875 C37.00694092 76.53229248 37.43966309 77.67786621 37.88549805 78.8581543 C38.8125 81.5625 38.8125 81.5625 38.8125 83.5625 C33.5325 83.5625 28.2525 83.5625 22.8125 83.5625 C20.09279284 78.31065169 17.80154449 73.13182457 15.8125 67.5625 C15.1525 67.5625 14.4925 67.5625 13.8125 67.5625 C13.4825 66.9025 13.1525 66.2425 12.8125 65.5625 C3.2425 65.5625 -6.3275 65.5625 -16.1875 65.5625 C-18.12022435 71.11108587 -18.12022435 71.11108587 -20.04663086 76.66186523 C-20.28776611 77.34966064 -20.52890137 78.03745605 -20.77734375 78.74609375 C-21.02347412 79.45306396 -21.26960449 80.16003418 -21.52319336 80.88842773 C-22.1875 82.5625 -22.1875 82.5625 -23.1875 83.5625 C-26.05017567 83.63575168 -28.888219 83.65488205 -31.75 83.625 C-32.55630859 83.62048828 -33.36261719 83.61597656 -34.19335938 83.61132812 C-36.19143756 83.59950518 -38.18947783 83.58156914 -40.1875 83.5625 C-36.78821922 73.62024268 -33.26444681 63.72850246 -29.60546875 53.87890625 C-29.29035339 53.02949463 -28.97523804 52.18008301 -28.65057373 51.30493164 C-27.04415205 46.97672988 -25.43190433 42.65081451 -23.81201172 38.32763672 C-23.20912777 36.70677346 -22.60641845 35.08584523 -22.00390625 33.46484375 C-21.71984421 32.7124794 -21.43578217 31.96011505 -21.14311218 31.18495178 C-20.02870702 28.17488947 -19.1875 25.79980543 -19.1875 22.5625 C-18.5275 22.5625 -17.8675 22.5625 -17.1875 22.5625 C-17.00574219 21.9334375 -16.82398438 21.304375 -16.63671875 20.65625 C-15.39663963 16.43362161 -14.12182478 12.28067683 -12.5 8.1875 C-10.96053928 4.57820487 -10.96053928 4.57820487 -11.1875 0.5625 C-7.35939179 -0.71353607 -3.95274893 -0.30033987 0 0 Z M-1.1875 20.5625 C-2.64183934 24.34834492 -4.08395676 28.13859469 -5.51489258 31.93334961 C-6.00341173 33.22368266 -6.49525575 34.51276199 -6.99047852 35.80053711 C-7.70160167 37.65145445 -8.39981337 39.50731615 -9.09765625 41.36328125 C-9.52183838 42.47872314 -9.94602051 43.59416504 -10.38305664 44.7434082 C-11.48663267 47.60578548 -11.48663267 47.60578548 -10.1875 50.5625 C-9.62804687 50.3871875 -9.06859375 50.211875 -8.4921875 50.03125 C-5.89386733 49.5027781 -3.93295916 49.70330934 -1.3125 50.0625 C2.62048249 50.52212369 5.92121503 50.48412012 9.8125 49.5625 C8.1716074 43.44513723 6.10578949 37.55978864 3.75 31.6875 C3.4926709 31.04546631 3.2353418 30.40343262 2.97021484 29.74194336 C1.69918072 26.61365478 0.34358723 23.57059271 -1.1875 20.5625 Z ",
    fill: "#13374B",
    transform: "translate(852.1875,404.4375)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.9135846 4.09561179 7.6875 8.97751653 7.6875 14.8125 C0.7575 17.7825 0.7575 17.7825 -6.3125 20.8125 C-7.055 19.554375 -7.7975 18.29625 -8.5625 17 C-10.91701724 13.24603731 -12.89220935 10.73054128 -17.125 9.125 C-22.22813347 8.39598093 -26.70855245 8.31321418 -31.3125 10.8125 C-33.6194254 13.68844836 -33.6194254 13.68844836 -33.375 17.25 C-32.65190185 21.04592015 -32.65190185 21.04592015 -29.30078125 22.85546875 C-25.18141052 25.03631208 -20.88668373 26.35161874 -16.4375 27.6875 C-7.75912587 30.44255339 0.7516885 33.64942714 5.6875 41.8125 C9.09208763 48.96355854 9.4401241 55.47883854 6.96484375 63.01171875 C3.83896625 70.1159858 -1.25874858 74.18991767 -8.3125 77.1875 C-17.37929243 80.20558974 -27.0154167 79.27857852 -36.3125 77.8125 C-36.3125 77.1525 -36.3125 76.4925 -36.3125 75.8125 C-37.1375 75.6475 -37.9625 75.4825 -38.8125 75.3125 C-44.85032706 72.72485983 -48.89282497 68.04956368 -52.375 62.5625 C-53.40248201 59.54855278 -53.62784987 58.65964971 -52.3125 55.8125 C-49.6953125 54.29296875 -49.6953125 54.29296875 -46.4375 53 C-45.36757813 52.56042969 -44.29765625 52.12085938 -43.1953125 51.66796875 C-40.3125 50.8125 -40.3125 50.8125 -37.3125 51.8125 C-36.63808869 53.4760479 -35.9724679 55.14316942 -35.3125 56.8125 C-32.22887533 60.41006211 -29.4613785 62.56590739 -24.69140625 63.11328125 C-17.39393795 63.34384727 -17.39393795 63.34384727 -11.3125 59.8125 C-9.67743443 56.54236886 -9.12275862 54.71904217 -9.875 51.125 C-13.18597264 45.79865271 -19.86691123 44.44889897 -25.5 42.5 C-33.93422957 39.49052814 -41.97815393 36.3652718 -48.3125 29.8125 C-49.17875 29.19375 -49.17875 29.19375 -50.0625 28.5625 C-51.3125 26.8125 -51.3125 26.8125 -51 23.125 C-50.6596875 21.4853125 -50.6596875 21.4853125 -50.3125 19.8125 C-51.3025 19.8125 -52.2925 19.8125 -53.3125 19.8125 C-52.8175 18.3275 -52.8175 18.3275 -52.3125 16.8125 C-52.11011719 16.13574219 -51.90773438 15.45898438 -51.69921875 14.76171875 C-49.00328227 6.04134322 -45.0707287 0.66706416 -37.3125 -4.1875 C-24.93673457 -9.71709732 -11.0358338 -7.28781477 0 0 Z ",
    fill: "#14384C",
    transform: "translate(613.3125,410.1875)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.48831242 0.00667405 2.97660807 0.01863442 4.46484375 0.03515625 C5.22345703 0.03966797 5.98207031 0.04417969 6.76367188 0.04882812 C8.64326246 0.06064945 10.52281274 0.07858547 12.40234375 0.09765625 C19.16431517 14.70351452 24.51053476 29.97759586 30.18896484 45.02612305 C32.4528761 51.01300625 34.74133307 56.98704246 37.109375 62.93359375 C37.52848145 63.98780518 37.94758789 65.0420166 38.37939453 66.12817383 C39.16731229 68.10178228 39.96096699 70.07311322 40.76123047 72.04174805 C41.11072754 72.91742432 41.46022461 73.79310059 41.8203125 74.6953125 C42.12735107 75.45336182 42.43438965 76.21141113 42.75073242 76.99243164 C43.40234375 79.09765625 43.40234375 79.09765625 43.40234375 83.09765625 C37.46234375 83.09765625 31.52234375 83.09765625 25.40234375 83.09765625 C24.97916667 81.01432292 24.55598958 78.93098958 24.1328125 76.84765625 C23.15907395 73.18181701 21.73414085 69.64911519 20.40234375 66.09765625 C9.84234375 66.09765625 -0.71765625 66.09765625 -11.59765625 66.09765625 C-13.57765625 71.70765625 -15.55765625 77.31765625 -17.59765625 83.09765625 C-23.20765625 83.09765625 -28.81765625 83.09765625 -34.59765625 83.09765625 C-33.86938263 79.45628813 -33.11828221 76.52555675 -31.83984375 73.109375 C-31.46875488 72.11220459 -31.09766602 71.11503418 -30.71533203 70.08764648 C-30.30524902 68.99782471 -29.89516602 67.90800293 -29.47265625 66.78515625 C-28.82852783 65.06051147 -28.82852783 65.06051147 -28.17138672 63.30102539 C-27.20186314 60.70566847 -26.22969293 58.11132084 -25.25585938 55.51757812 C-23.74582378 51.49493107 -22.24143178 47.4701902 -20.73788452 43.44511414 C-19.06767431 38.97455469 -17.39516879 34.50485474 -15.72265625 30.03515625 C-15.39859802 29.16853363 -15.07453979 28.30191101 -14.74066162 27.4090271 C-4.53269745 0.12303739 -4.53269745 0.12303739 0 0 Z M3.40234375 21.09765625 C4.40234375 23.09765625 4.40234375 23.09765625 4.40234375 23.09765625 Z M4.40234375 23.09765625 C1.9640933 25.9512017 0.62411281 28.71472091 -0.640625 32.23046875 C-0.99189453 33.20113281 -1.34316406 34.17179688 -1.70507812 35.171875 C-2.06150391 36.17863281 -2.41792969 37.18539062 -2.78515625 38.22265625 C-3.15318359 39.23714844 -3.52121094 40.25164063 -3.90039062 41.296875 C-5.82760775 46.08250805 -5.82760775 46.08250805 -6.59765625 51.09765625 C0.33234375 51.09765625 7.26234375 51.09765625 14.40234375 51.09765625 C13.71144535 46.26136748 13.24260734 43.13388541 11.5546875 38.8203125 C11.01811523 37.43295898 11.01811523 37.43295898 10.47070312 36.01757812 C9.91092773 34.6031543 9.91092773 34.6031543 9.33984375 33.16015625 C8.96279297 32.19013672 8.58574219 31.22011719 8.19726562 30.22070312 C7.27221909 27.84368482 6.34045193 25.46954308 5.40234375 23.09765625 C5.07234375 23.09765625 4.74234375 23.09765625 4.40234375 23.09765625 Z ",
    fill: "#14384B",
    transform: "translate(710.59765625,517.90234375)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C5.08248264 1.06022373 7.16691037 1.06048651 9.25 1.02734375 C10.49910156 1.01509766 11.74820313 1.00285156 13.03515625 0.99023438 C15.64719646 0.95549295 18.25918452 0.91653477 20.87109375 0.87304688 C34.00424411 0.75878712 43.56304252 1.74619485 53.75 10.3125 C59.6541942 17.36473196 60.66934193 23.10852121 60.375 32.37109375 C59.64146116 39.46961025 57.41630769 43.97310963 52.25 48.875 C48.40521977 51.96366389 44.69606777 53.62671229 40 55 C38.96875 55.4125 37.9375 55.825 36.875 56.25 C30.87912402 57.41049212 25.04193516 56.6201154 19 56 C17.65893595 58.6821281 17.78549581 60.88398032 17.68359375 63.8828125 C17.64169922 65.04941406 17.59980469 66.21601562 17.55664062 67.41796875 C17.51732422 68.64128906 17.47800781 69.86460937 17.4375 71.125 C17.39431641 72.35605469 17.35113281 73.58710937 17.30664062 74.85546875 C17.20031377 77.90350512 17.09963028 80.95173739 17 84 C11.06 84 5.12 84 -1 84 C-1 75.85714286 -1 75.85714286 0 72 C-0.33 71.01 -0.66 70.02 -1 69 C-1.09653784 66.53318509 -1.14000913 64.09554082 -1.1328125 61.62890625 C-1.13376923 60.9101683 -1.13472595 60.19143036 -1.13571167 59.45091248 C-1.13639158 57.93203646 -1.13455044 56.41315752 -1.13037109 54.89428711 C-1.12502796 52.57464023 -1.13031838 50.25518767 -1.13671875 47.93554688 C-1.13605778 46.45833291 -1.13477623 44.98111906 -1.1328125 43.50390625 C-1.13483673 42.81212784 -1.13686096 42.12034943 -1.13894653 41.40760803 C-1.12291727 38.09869243 -0.85881391 35.18855427 0 32 C-0.33 31.67 -0.66 31.34 -1 31 C-1.10005826 28.87819862 -1.13081087 26.75306461 -1.1328125 24.62890625 C-1.13410156 23.33275391 -1.13539063 22.03660156 -1.13671875 20.70117188 C-1.13462402 20.0223999 -1.1325293 19.34362793 -1.13037109 18.64428711 C-1.1250313 16.57463211 -1.13031193 14.505195 -1.13671875 12.43554688 C-1.13542969 11.13810547 -1.13414062 9.84066406 -1.1328125 8.50390625 C-1.13168457 7.30580322 -1.13055664 6.1077002 -1.12939453 4.87329102 C-1 2 -1 2 0 0 Z M17 16 C17 24.58 17 33.16 17 42 C29.61500324 42.62442464 29.61500324 42.62442464 40.9375 38.0625 C43.95919092 33.57574682 43.74590343 29.26843372 43 24 C41.60559683 20.59145891 40.18206699 18.90924019 37 17 C32.74778972 15.85576887 28.55611175 15.8835783 24.1875 15.9375 C20.6296875 15.9684375 20.6296875 15.9684375 17 16 Z M0 25 C1 27 1 27 1 27 Z ",
    fill: "#14394D",
    transform: "translate(545,517)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.5546875 2.8359375 0.5546875 2.8359375 0.875 6.375 C0.99617187 7.53773438 1.11734375 8.70046875 1.2421875 9.8984375 C1 13 1 13 -0.8515625 14.87109375 C-2.92091623 15.95844507 -4.70501736 16.59018167 -7 17 C-7 16.34 -7 15.68 -7 15 C-12.94 15 -18.88 15 -25 15 C-24.855625 16.93875 -24.71125 18.8775 -24.5625 20.875 C-24.48128906 21.96554687 -24.40007813 23.05609375 -24.31640625 24.1796875 C-24.16998297 26.94728971 -24.16998297 26.94728971 -23 29 C-23.66 29 -24.32 29 -25 29 C-24.835 29.639375 -24.67 30.27875 -24.5 30.9375 C-23.94702392 34.32447848 -23.96908052 37.4925742 -24.0625 40.9140625 C-24.09420333 43.19684617 -24.09420333 43.19684617 -23 46 C-23.66 46 -24.32 46 -25 46 C-24.505 46.8353125 -24.505 46.8353125 -24 47.6875 C-22.8690399 50.30284522 -22.84337026 52.1806646 -23 55 C-23.33 55 -23.66 55 -24 55 C-24.33 58.96 -24.66 62.92 -25 67 C-24.34 67 -23.68 67 -23 67 C-23.185625 67.556875 -23.37125 68.11375 -23.5625 68.6875 C-24.08119018 71.4291481 -23.59530945 73.28803472 -23 76 C-22.9629721 77.6662553 -22.95240038 79.33401319 -23 81 C-28.3748385 83.68741925 -34.99074787 82 -41 82 C-41.33 60.22 -41.66 38.44 -42 16 C-45.89361887 14.70212704 -49.5732148 14.93313886 -53.625 15 C-56.42257853 15.04571207 -59.20112575 15.04713893 -62 15 C-63 14 -63 14 -63.09765625 10.83984375 C-63.08025391 8.90818359 -63.08025391 8.90818359 -63.0625 6.9375 C-63.05347656 5.64714844 -63.04445313 4.35679687 -63.03515625 3.02734375 C-63.02355469 2.02832031 -63.01195312 1.02929688 -63 0 C-55.08123253 -0.15371916 -47.16238929 -0.30190064 -39.24338722 -0.4429636 C-35.56649721 -0.50863598 -31.88966339 -0.57623368 -28.21289062 -0.64819336 C-24.66628415 -0.71753528 -21.1196193 -0.78186953 -17.5728569 -0.84269524 C-16.21800804 -0.86681786 -14.86319036 -0.89276147 -13.50841141 -0.92053413 C-11.61458557 -0.95904959 -9.72062114 -0.99055898 -7.82666016 -1.02172852 C-6.20783432 -1.05170677 -6.20783432 -1.05170677 -4.55630493 -1.08229065 C-2 -1 -2 -1 0 0 Z M-25 77 C-24 80 -24 80 -24 80 Z ",
    fill: "#11374C",
    transform: "translate(679,519)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.9590625 0.2165625 0.9590625 0.2165625 1.9375 0.4375 C5.92521894 1.16993817 9.97037221 1.55226358 14 2 C14 29.39 14 56.78 14 85 C8.72 85 3.44 85 -2 85 C-2 57.61 -2 30.22 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#15394C",
    transform: "translate(530,403)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.33 10.56 0.66 16 1 C16 28.39 16 55.78 16 84 C10.06 84 4.12 84 -2 84 C-2.02293216 79.19443933 -2.04285248 74.38906785 -2.05493164 69.58349609 C-2.05996621 67.94807289 -2.06679427 66.3126542 -2.07543945 64.67724609 C-2.08754335 62.32909025 -2.093237 59.98099381 -2.09765625 57.6328125 C-2.10281754 56.89942657 -2.10797882 56.16604065 -2.11329651 55.41043091 C-2.11387171 50.22774341 -2.11387171 50.22774341 -1 48 C-0.34 48 0.32 48 1 48 C1 59.55 1 71.1 1 83 C5.62 83 10.24 83 15 83 C15 56.27 15 29.54 15 2 C10.05 2.33 5.1 2.66 0 3 C-0.33 4.65 -0.66 6.3 -1 8 C-1.33 8 -1.66 8 -2 8 C-2.125 5.125 -2.125 5.125 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z M-1 57 C0 60 0 60 0 60 Z M-1 69 C0 71 0 71 0 71 Z ",
    fill: "#547685",
    transform: "translate(690,404)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2.61669922 2.68701172 C3.08147679 5.49166313 3.12977386 8.16407992 3.1328125 11.0078125 C3.13410156 12.15894531 3.13539063 13.31007813 3.13671875 14.49609375 C3.13285156 15.69363281 3.12898437 16.89117187 3.125 18.125 C3.13080078 19.93291016 3.13080078 19.93291016 3.13671875 21.77734375 C3.13542969 22.92589844 3.13414062 24.07445312 3.1328125 25.2578125 C3.13168457 26.3111377 3.13055664 27.36446289 3.12939453 28.44970703 C3 31 3 31 2 33 C2.66 33 3.32 33 4 33 C4 33.99 4 34.98 4 36 C3.01 36 2.02 36 1 36 C1 25.44 1 14.88 1 4 C-3.62 4 -8.24 4 -13 4 C-13 30.73 -13 57.46 -13 85 C-8.38 85 -3.76 85 1 85 C1 73.45 1 61.9 1 50 C3.05363756 54.10727512 3.22916753 55.71047091 3.16015625 60.15625 C3.14919922 61.34347656 3.13824219 62.53070313 3.12695312 63.75390625 C3.10568359 64.99011719 3.08441406 66.22632813 3.0625 67.5 C3.02804111 69.94785732 2.99790675 72.39578037 2.97265625 74.84375 C2.95468994 75.92849609 2.93672363 77.01324219 2.91821289 78.13085938 C2.98942473 80.62901338 3.37810413 82.605788 4 85 C1.89868615 87.10131385 -2.54146322 86.18514741 -5.4375 86.1875 C-6.22705078 86.19974609 -7.01660156 86.21199219 -7.83007812 86.22460938 C-9.88807435 86.22987279 -11.94562009 86.12206285 -14 86 C-14.66 85.34 -15.32 84.68 -16 84 C-15.34 84 -14.68 84 -14 84 C-14 56.94 -14 29.88 -14 2 C-7.07 2.495 -7.07 2.495 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#345261",
    transform: "translate(652,402)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.67 23.44 1.34 45.88 1 69 C5.62 69 10.24 69 15 69 C15 46.89 15 24.78 15 2 C15.99 2.33 16.98 2.66 18 3 C17.34 3 16.68 3 16 3 C16.14076315 4.9587043 16.2877676 6.91696093 16.4375 8.875 C16.51871094 9.96554687 16.59992187 11.05609375 16.68359375 12.1796875 C16.83001703 14.94728971 16.83001703 14.94728971 18 17 C17.34 17 16.68 17 16 17 C16.165 17.639375 16.33 18.27875 16.5 18.9375 C17.05297608 22.32447848 17.03091948 25.4925742 16.9375 28.9140625 C16.90579667 31.19684617 16.90579667 31.19684617 18 34 C17.34 34 16.68 34 16 34 C16.495 34.8353125 16.495 34.8353125 17 35.6875 C18.1309601 38.30284522 18.15662974 40.1806646 18 43 C17.67 43 17.34 43 17 43 C16.67 46.96 16.34 50.92 16 55 C16.66 55 17.32 55 18 55 C17.814375 55.556875 17.62875 56.11375 17.4375 56.6875 C16.91880982 59.4291481 17.40469055 61.28803472 18 64 C18.0370279 65.6662553 18.04759962 67.33401319 18 69 C14.81175432 70.59412284 11.37103338 70.10174735 7.875 70.0625 C7.12089844 70.05798828 6.36679687 70.05347656 5.58984375 70.04882812 C3.72652873 70.03703499 1.86325445 70.01909942 0 70 C-0.00808685 69.1775882 -0.01617371 68.35517639 -0.02450562 67.50784302 C-0.10235881 59.76763178 -0.18962089 52.02761158 -0.28752708 44.28763008 C-0.33753106 40.30816273 -0.38386047 36.32872247 -0.421875 32.34912109 C-0.45867637 28.51053118 -0.50502175 24.6721656 -0.55806351 20.83376694 C-0.57663497 19.36734822 -0.59173272 17.90088137 -0.60334396 16.43439102 C-0.62015988 14.38457379 -0.64918198 12.33527344 -0.68115234 10.28564453 C-0.69447601 9.11760284 -0.70779968 7.94956116 -0.7215271 6.74612427 C-0.72226567 3.85629428 -0.72226567 3.85629428 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z M16 65 C17 68 17 68 17 68 Z ",
    fill: "#355463",
    transform: "translate(638,531)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0 15.84 0 24 0 C24 0.66 24 1.32 24 2 C21.29204274 2.19601027 18.58400195 2.38204839 15.875 2.5625 C15.11445312 2.61857422 14.35390625 2.67464844 13.5703125 2.73242188 C12.44882812 2.80493164 12.44882812 2.80493164 11.3046875 2.87890625 C10.2835083 2.94960327 10.2835083 2.94960327 9.24169922 3.02172852 C7 3 7 3 1 2 C1 24.11 1 46.22 1 69 C-3.62 69 -8.24 69 -13 69 C-13 46.56 -13 24.12 -13 1 C-12.67 1 -12.34 1 -12 1 C-12 23.11 -12 45.22 -12 68 C-8.04 68 -4.08 68 0 68 C0 45.56 0 23.12 0 0 Z ",
    fill: "#000E1B",
    transform: "translate(652,531)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.0257783 7.34561271 2.04304216 13.69121148 2.05493164 20.03686523 C2.05989863 22.18660995 2.06667448 24.3363514 2.07543945 26.48608398 C2.12919234 40.02864963 1.89003692 53.48488463 1 67 C-0.485 67.495 -0.485 67.495 -2 68 C-2.02474682 63.08870815 -2.04288223 58.17745273 -2.05493164 53.26611328 C-2.05995569 51.59585945 -2.06677605 49.92561001 -2.07543945 48.25537109 C-2.08758946 45.85252804 -2.09324763 43.44974321 -2.09765625 41.046875 C-2.10281754 40.30193787 -2.10797882 39.55700073 -2.11329651 38.78948975 C-2.11366718 35.35215756 -1.91575569 32.31060969 -1 29 C-1.33 28.67 -1.66 28.34 -2 28 C-2.04080783 26.00041636 -2.04254356 23.99954746 -2 22 C-1.67 22 -1.34 22 -1 22 C-0.67 14.74 -0.34 7.48 0 0 Z ",
    fill: "#24404F",
    transform: "translate(546,520)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C4.96 3.33 8.92 3.66 13 4 C13.33 3.34 13.66 2.68 14 2 C15.15746602 5.66554103 15.10718502 9.09769646 15.08178711 12.92407227 C15.07872055 13.612341 15.07565399 14.30060974 15.07249451 15.00973511 C15.06535643 16.49988031 15.05597534 17.99001609 15.04459953 19.48013496 C15.0271855 21.83783213 15.01690311 24.19546132 15.00868225 26.5532074 C14.98424472 33.25518214 14.9485797 39.95706487 14.90405273 46.65893555 C14.87729422 50.76135086 14.86023677 54.86371365 14.84918404 58.96619987 C14.84297095 60.52953984 14.8329615 62.09286945 14.81910515 63.65616035 C14.79992128 65.83928256 14.79299778 68.02212723 14.78881836 70.20532227 C14.78136093 71.44790298 14.7739035 72.6904837 14.76622009 73.97071838 C14.76534803 77.17780881 14.76534803 77.17780881 17 80 C15.625 83.6875 15.625 83.6875 14 87 C9.05 87 4.1 87 -1 87 C-1 86.67 -1 86.34 -1 86 C3.62 86 8.24 86 13 86 C13 59.27 13 32.54 13 5 C8.05 5.33 3.1 5.66 -2 6 C-1.34 4.02 -0.68 2.04 0 0 Z ",
    fill: "#334E5C",
    transform: "translate(783,401)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.21 0 24.42 0 37 0 C37 2.97 37 5.94 37 9 C36.67 9 36.34 9 36 9 C36 6.69 36 4.38 36 2 C25.11 2 14.22 2 3 2 C3 4.97 3 7.94 3 11 C8.94 11 14.88 11 21 11 C20.67 11.66 20.34 12.32 20 13 C15.69185156 14.01631395 11.53608185 14.10751104 7.125 14.0625 C5.97257812 14.05347656 4.82015625 14.04445313 3.6328125 14.03515625 C2.76398438 14.02355469 1.89515625 14.01195312 1 14 C-1.09231398 9.81537205 0 4.67855628 0 0 Z ",
    fill: "#132B3B",
    transform: "translate(404,557)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.66 2.33 2.32 2.66 3 3 C2.34 3 1.68 3 1 3 C1 21.15 1 39.3 1 58 C-1.18971746 54.71542381 -1.24583902 53.7824019 -1.22705078 49.9777832 C-1.22689972 48.95695145 -1.22674866 47.93611969 -1.22659302 46.88435364 C-1.21110916 45.23423531 -1.21110916 45.23423531 -1.1953125 43.55078125 C-1.1924826 42.4230278 -1.18965271 41.29527435 -1.18673706 40.13334656 C-1.17552916 36.52629042 -1.15042323 32.91948127 -1.125 29.3125 C-1.114971 26.86914421 -1.10584501 24.42578453 -1.09765625 21.98242188 C-1.07558783 15.98819677 -1.04210417 9.99411603 -1 4 C-1.69867188 4.02320313 -2.39734375 4.04640625 -3.1171875 4.0703125 C-4.02726562 4.08835937 -4.93734375 4.10640625 -5.875 4.125 C-6.77992188 4.14820313 -7.68484375 4.17140625 -8.6171875 4.1953125 C-11 4 -11 4 -13 2 C-12.14535156 1.93941406 -11.29070312 1.87882813 -10.41015625 1.81640625 C-8.75306641 1.69072266 -8.75306641 1.69072266 -7.0625 1.5625 C-5.96035156 1.48128906 -4.85820312 1.40007813 -3.72265625 1.31640625 C-1.08890097 1.29581916 -1.08890097 1.29581916 0 0 Z ",
    fill: "#132937",
    transform: "translate(473,517)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.33 10 0.66 10 1 C7.69 1.33 5.38 1.66 3 2 C2.67 20.15 2.34 38.3 2 57 C1.01 57.495 1.01 57.495 0 58 C0 38.86 0 19.72 0 0 Z ",
    fill: "#29424E",
    transform: "translate(510,519)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.33 10.56 0.66 16 1 C16.04600738 5.60840616 16.08580328 10.21600975 16.10986328 14.82446289 C16.11989726 16.39089667 16.13352754 17.95731183 16.15087891 19.52368164 C16.17524225 21.78015753 16.18650916 24.03638494 16.1953125 26.29296875 C16.20563507 26.98899704 16.21595764 27.68502533 16.22659302 28.40214539 C16.22750439 32.38584491 15.7555827 35.41290109 14 39 C13.67 39 13.34 39 13 39 C13 27.12 13 15.24 13 3 C6.565 3.495 6.565 3.495 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#1A3240",
    transform: "translate(367,404)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.21919747 16.1448587 2.19709521 30.99305506 0 46 C-3.33285068 42.13952125 -3.37714819 39.67432721 -3.234375 34.734375 C-3.01261773 32.14720683 -2.59614893 29.72637521 -2.0625 27.1875 C-0.24226531 18.27996856 -0.31039843 9.06085812 0 0 Z ",
    fill: "#223D4C",
    transform: "translate(315,418)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2.60522461 2.57324219 C3.15986475 5.98271838 3.23675648 9.38209036 3.31640625 12.828125 C3.33718735 13.57713074 3.35796844 14.32613647 3.37937927 15.09783936 C3.44457088 17.48180288 3.50361783 19.86587312 3.5625 22.25 C3.60571416 23.86980254 3.64932937 25.48959443 3.69335938 27.109375 C3.80022096 31.07280832 3.90157333 35.0363486 4 39 C1.69297666 35.53946498 0.88067473 33.851823 0.71875 29.7890625 C0.68136719 28.95632813 0.64398438 28.12359375 0.60546875 27.265625 C0.57066406 26.39421875 0.53585938 25.5228125 0.5 24.625 C0.43083563 22.90869885 0.35804525 21.19253915 0.28125 19.4765625 C0.25095703 18.71424316 0.22066406 17.95192383 0.18945312 17.16650391 C0.00143396 15.01639817 -0.47663226 13.08862745 -1 11 C-0.91685386 9.07959244 -0.76727868 7.16126769 -0.5625 5.25 C-0.46066406 4.26515625 -0.35882813 3.2803125 -0.25390625 2.265625 C-0.17011719 1.51796875 -0.08632812 0.7703125 0 0 Z ",
    fill: "#041928",
    transform: "translate(178,577)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 11.55 2 23.1 2 35 C0.515 35.495 0.515 35.495 -1 36 C-1.02468447 31.19450253 -1.04285255 26.38904182 -1.05493164 21.58349609 C-1.05996621 19.94807289 -1.06679427 18.3126542 -1.07543945 16.67724609 C-1.08754335 14.32909025 -1.093237 11.98099381 -1.09765625 9.6328125 C-1.10281754 8.89942657 -1.10797882 8.16604065 -1.11329651 7.41043091 C-1.11387171 2.22774341 -1.11387171 2.22774341 0 0 Z M0 9 C1 12 1 12 1 12 Z M0 21 C1 23 1 23 1 23 Z ",
    fill: "#385665",
    transform: "translate(689,452)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.9821994 3.27626375 4.11580914 6.22788119 4.09765625 9.640625 C4.09282227 11.24550781 4.09282227 11.24550781 4.08789062 12.8828125 C4.07951172 13.99398437 4.07113281 15.10515625 4.0625 16.25 C4.05798828 17.37664063 4.05347656 18.50328125 4.04882812 19.6640625 C4.03705397 22.44276217 4.0206084 25.22135409 4 28 C3.34 28.33 2.68 28.66 2 29 C1.855625 27.948125 1.71125 26.89625 1.5625 25.8125 C1.09681828 22.2529902 1.09681828 22.2529902 0.46875 19.8125 C-0.1791502 15.92509878 -0.10535472 12.12024501 -0.0625 8.1875 C-0.05573242 7.00510742 -0.05573242 7.00510742 -0.04882812 5.79882812 C-0.03711312 3.86585239 -0.01917998 1.93291607 0 0 Z ",
    fill: "#243F4F",
    transform: "translate(456,519)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 11.89 2 22.78 2 34 C1.34 34 0.68 34 0 34 C-0.90750873 27.19368454 -1.110196 20.48171866 -1.125 13.625 C-1.12951172 12.74489258 -1.13402344 11.86478516 -1.13867188 10.95800781 C-1.13673828 10.11850586 -1.13480469 9.27900391 -1.1328125 8.4140625 C-1.13168457 7.6607666 -1.13055664 6.9074707 -1.12939453 6.13134766 C-0.99845555 3.97456025 -0.59143843 2.07385213 0 0 Z ",
    fill: "#152E3D",
    transform: "translate(782,426)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.74609375 2.2578125 1.74609375 2.2578125 3.4375 5.125 C5.49754162 8.55098714 7.5604058 11.8332844 10 15 C10.66 15.99 11.32 16.98 12 18 C11.67 18.99 11.34 19.98 11 21 C9.20753339 18.5630847 7.41599716 16.12549489 5.625 13.6875 C5.11710938 12.99720703 4.60921875 12.30691406 4.0859375 11.59570312 C3.59609375 10.92861328 3.10625 10.26152344 2.6015625 9.57421875 C1.92601318 8.65515747 1.92601318 8.65515747 1.23681641 7.7175293 C0.12239357 6.16996423 -0.94215082 4.58677377 -2 3 C-5.34613512 2.41312216 -5.34613512 2.41312216 -9.125 2.3125 C-10.40632812 2.24675781 -11.68765625 2.18101562 -13.0078125 2.11328125 C-13.99523437 2.07589844 -14.98265625 2.03851563 -16 2 C-16 1.34 -16 0.68 -16 0 C-14.08416353 -0.1958009 -12.16727461 -0.38132214 -10.25 -0.5625 C-8.64898438 -0.71912109 -8.64898438 -0.71912109 -7.015625 -0.87890625 C-2.29906429 -1.06830182 -2.29906429 -1.06830182 0 0 Z ",
    fill: "#1B323F",
    transform: "translate(744,405)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.5546875 2.8359375 0.5546875 2.8359375 0.875 6.375 C0.99617187 7.53773438 1.11734375 8.70046875 1.2421875 9.8984375 C1 13 1 13 -0.8515625 14.87109375 C-2.92091623 15.95844507 -4.70501736 16.59018167 -7 17 C-7 16.34 -7 15.68 -7 15 C-9.97 15 -12.94 15 -16 15 C-16 14.67 -16 14.34 -16 14 C-11.71 14 -7.42 14 -3 14 C-3 9.71 -3 5.42 -3 1 C-4.32 0.67 -5.64 0.34 -7 0 C-2.25 -1.125 -2.25 -1.125 0 0 Z ",
    fill: "#304C59",
    transform: "translate(679,519)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.96 1 7.92 1 12 C7.93 12 14.86 12 22 12 C21.67 12.66 21.34 13.32 21 14 C17.11436275 15.29521242 13.42199731 15.14503464 9.375 15.125 C8.58609375 15.12886719 7.7971875 15.13273438 6.984375 15.13671875 C1.12665394 15.12665394 1.12665394 15.12665394 0 14 C-0.07271741 11.64686445 -0.08370868 9.29166332 -0.0625 6.9375 C-0.05347656 5.64714844 -0.04445313 4.35679687 -0.03515625 3.02734375 C-0.02355469 2.02832031 -0.01195312 1.02929688 0 0 Z ",
    fill: "#233E4E",
    transform: "translate(616,519)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.97679687 2.26457031 1.95359375 3.52914063 1.9296875 4.83203125 C1.91092874 6.4921816 1.89272865 8.15233833 1.875 9.8125 C1.85824219 10.64587891 1.84148438 11.47925781 1.82421875 12.33789062 C1.81455078 13.54155273 1.81455078 13.54155273 1.8046875 14.76953125 C1.78897705 15.87711792 1.78897705 15.87711792 1.77294922 17.00708008 C1.88258521 19.31890676 1.88258521 19.31890676 4 22 C2.625 25.6875 2.625 25.6875 1 29 C-3.95 29 -8.9 29 -14 29 C-14 28.67 -14 28.34 -14 28 C-9.38 28 -4.76 28 0 28 C0 18.76 0 9.52 0 0 Z ",
    fill: "#3F5D6C",
    transform: "translate(796,459)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.08678303 3.95819611 2.14031733 7.91614934 2.1875 11.875 C2.21263672 13.00292969 2.23777344 14.13085938 2.26367188 15.29296875 C2.27817383 16.90751953 2.27817383 16.90751953 2.29296875 18.5546875 C2.31653442 20.04718018 2.31653442 20.04718018 2.34057617 21.56982422 C2.22818604 22.37178223 2.1157959 23.17374023 2 24 C-1.4352048 26.29013653 -2.985331 26.17842973 -7 26 C-7 25.67 -7 25.34 -7 25 C-5.35 24.67 -3.7 24.34 -2 24 C-1.08110847 21.24332541 -0.89187298 19.70387521 -0.9375 16.875 C-0.94523438 16.08609375 -0.95296875 15.2971875 -0.9609375 14.484375 C-0.97382813 13.66453125 -0.98671875 12.8446875 -1 12 C-1.02554926 10.3750673 -1.04656808 8.75005545 -1.0625 7.125 C-1.07410156 6.40570312 -1.08570313 5.68640625 -1.09765625 4.9453125 C-1 3 -1 3 0 0 Z ",
    fill: "#1D3543",
    transform: "translate(192,595)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.22506898 0.65357278 -2.45529516 1.29748233 -3.6875 1.9375 C-4.37199219 2.29714844 -5.05648438 2.65679688 -5.76171875 3.02734375 C-10.93438283 5.27515065 -16.08545114 5.15335947 -21.625 5.125 C-22.7696875 5.13080078 -22.7696875 5.13080078 -23.9375 5.13671875 C-27.21351362 5.13097136 -29.87137676 5.04287441 -33 4 C-33 3.34 -33 2.68 -33 2 C-32.40574219 2.01571045 -31.81148438 2.0314209 -31.19921875 2.04760742 C-28.46624546 2.11056569 -25.73342545 2.14918095 -23 2.1875 C-22.06542969 2.21263672 -21.13085938 2.23777344 -20.16796875 2.26367188 C-15.58947097 2.31169808 -11.83414496 2.16633788 -7.5625 0.42578125 C-3.95969205 -1.01613202 -3.41118973 -1.13065945 0 0 Z ",
    fill: "#203643",
    transform: "translate(425,597)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.625 2.5 3.625 2.5 5 5 C4 6 4 6 2.23413086 6.11352539 C1.48526611 6.10828857 0.73640137 6.10305176 -0.03515625 6.09765625 C-0.84404297 6.09443359 -1.65292969 6.09121094 -2.48632812 6.08789062 C-3.33646484 6.07951172 -4.18660156 6.07113281 -5.0625 6.0625 C-5.91650391 6.05798828 -6.77050781 6.05347656 -7.65039062 6.04882812 C-9.76695663 6.03700373 -11.88348685 6.01906769 -14 6 C-14 5.01 -14 4.02 -14 3 C-9.38 3 -4.76 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#203B49",
    transform: "translate(507,482)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-3.99998437 2.02927916 -7.99994076 2.04689219 -12 2.0625 C-13.12535156 2.07087891 -14.25070312 2.07925781 -15.41015625 2.08789062 C-21.37584397 2.10533416 -27.10287573 1.91781223 -33 1 C-33 0.67 -33 0.34 -33 0 C-29.00047218 -0.1986252 -25.00037822 -0.38188092 -21 -0.5625 C-19.87464844 -0.61857422 -18.74929688 -0.67464844 -17.58984375 -0.73242188 C-11.57173883 -0.99637385 -5.94748744 -0.98395932 0 0 Z ",
    fill: "#0E2635",
    transform: "translate(584,519)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.39456452 0.00667256 2.78911118 0.01863093 4.18359375 0.03515625 C4.89451172 0.03966797 5.60542969 0.04417969 6.33789062 0.04882812 C8.09899388 0.06064761 9.86005411 0.07858362 11.62109375 0.09765625 C11.62109375 0.75765625 11.62109375 1.41765625 11.62109375 2.09765625 C7.00109375 2.09765625 2.38109375 2.09765625 -2.37890625 2.09765625 C-2.37890625 10.67765625 -2.37890625 19.25765625 -2.37890625 28.09765625 C-2.70890625 28.09765625 -3.03890625 28.09765625 -3.37890625 28.09765625 C-3.57471971 23.61881186 -3.75916985 19.13957199 -3.94140625 14.66015625 C-3.99748047 13.38076172 -4.05355469 12.10136719 -4.11132812 10.78320312 C-4.15966797 9.56826172 -4.20800781 8.35332031 -4.2578125 7.1015625 C-4.30494385 5.97564697 -4.3520752 4.84973145 -4.40063477 3.68969727 C-4.36767547 -0.24208692 -4.02869952 0.1164364 0 0 Z ",
    fill: "#2A4555",
    transform: "translate(564.37890625,530.90234375)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.02673828 0.72123047 1.02673828 0.72123047 2.07421875 1.45703125 C5.48736428 3.25702122 7.97692423 3.49378405 11.8125 3.6875 C13.55466797 3.78611328 13.55466797 3.78611328 15.33203125 3.88671875 C16.21246094 3.92410156 17.09289062 3.96148437 18 4 C17.67 3.01 17.34 2.02 17 1 C18.32 1.66 19.64 2.32 21 3 C21 3.99 21 4.98 21 6 C17.87517438 6.08687496 14.75065754 6.14034568 11.625 6.1875 C10.73554688 6.21263672 9.84609375 6.23777344 8.9296875 6.26367188 C7.65351563 6.27817383 7.65351563 6.27817383 6.3515625 6.29296875 C5.17327881 6.31653442 5.17327881 6.31653442 3.97119141 6.34057617 C3.32069824 6.22818604 2.67020508 6.1157959 2 6 C0 3 0 3 0 0 Z ",
    fill: "#243E4B",
    transform: "translate(411,482)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C1.11375 1.95875 2.2275 1.9175 3.375 1.875 C7 2 7 2 9 4 C2.07 4 -4.86 4 -12 4 C-12 3.01 -12 2.02 -12 1 C-7.93631321 0.22596442 -4.13574827 -0.0984702 0 0 Z ",
    fill: "#102F40",
    transform: "translate(716,568)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-8.86357853 6.66063139 -16.49991468 6.30237458 -25 6 C-25 5.34 -25 4.68 -25 4 C-24.44538086 3.9498877 -23.89076172 3.89977539 -23.31933594 3.84814453 C-20.79538036 3.61538326 -18.27276461 3.37031964 -15.75 3.125 C-14.87730469 3.04636719 -14.00460937 2.96773438 -13.10546875 2.88671875 C-11.83896484 2.76103516 -11.83896484 2.76103516 -10.546875 2.6328125 C-9.77182617 2.55949707 -8.99677734 2.48618164 -8.19824219 2.41064453 C-5.21629019 1.85359841 -3.01633838 0 0 0 Z ",
    fill: "#233B49",
    transform: "translate(609,483)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 10.23 1 20.46 1 31 C0.34 31.33 -0.32 31.66 -1 32 C-3.00519881 29.16913109 -3.08216415 27.14322623 -2.6875 23.8125 C-2 20 -2 20 -1 19 C-0.84379445 17.58672053 -0.74943827 16.1664541 -0.68359375 14.74609375 C-0.64169922 13.89208984 -0.59980469 13.03808594 -0.55664062 12.15820312 C-0.51732422 11.26037109 -0.47800781 10.36253906 -0.4375 9.4375 C-0.39431641 8.53580078 -0.35113281 7.63410156 -0.30664062 6.70507812 C-0.20021858 4.47021515 -0.09820012 2.23523692 0 0 Z ",
    fill: "#132D3D",
    transform: "translate(547,568)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.92 0 15.84 0 24 0 C24 0.66 24 1.32 24 2 C21.31288976 2.19647038 18.62571669 2.38239615 15.9375 2.5625 C15.18533203 2.61857422 14.43316406 2.67464844 13.65820312 2.73242188 C8.92140498 3.04000617 4.67457788 2.83807173 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#0A2130",
    transform: "translate(652,531)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19275481 4.34117362 1.37139593 8.68263202 1.53710938 13.02490234 C1.59542647 14.50129674 1.65756463 15.97754544 1.72363281 17.45361328 C1.81805803 19.57818061 1.89862513 21.70289674 1.9765625 23.828125 C2.02893066 25.1059082 2.08129883 26.38369141 2.13525391 27.70019531 C2.00728342 30.82230558 1.66891271 32.41403969 0 35 C-0.87226626 30.58874098 -1.05766677 26.5591877 -0.87890625 22.0703125 C-0.83056641 20.78125 -0.78222656 19.4921875 -0.73242188 18.1640625 C-0.67591408 16.81770275 -0.61927179 15.47134864 -0.5625 14.125 C-0.50920597 12.75522999 -0.45646622 11.3854383 -0.40429688 10.015625 C-0.27497734 6.67682977 -0.14002445 3.33836059 0 0 Z ",
    fill: "#0C1D27",
    transform: "translate(367,409)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.625 2.890625 3.625 2.890625 4 5.25 C4.9314523 10.13236248 6.44986496 13.44986496 10 17 C9.34 17.33 8.68 17.66 8 18 C6.32012773 16.68334336 4.65533995 15.34736973 3 14 C2.38125 13.566875 1.7625 13.13375 1.125 12.6875 C0 11 0 11 0.3125 7.3125 C0.539375 6.219375 0.76625 5.12625 1 4 C0.01 4 -0.98 4 -2 4 C-1 1 -1 1 0 0 Z ",
    fill: "#274251",
    transform: "translate(562,426)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.82976016 3.10996778 2.20629302 5.18182882 1.9765625 8.765625 C1.89921875 10.09980469 1.89921875 10.09980469 1.8203125 11.4609375 C1.75585938 12.38132812 1.69140625 13.30171875 1.625 14.25 C1.56828125 15.18585938 1.5115625 16.12171875 1.453125 17.0859375 C1.31197212 19.39143448 1.1605965 21.69578928 1 24 C0.34 24 -0.32 24 -1 24 C-1.02887236 20.18751574 -1.04675492 16.3750593 -1.0625 12.5625 C-1.07087891 11.47388672 -1.07925781 10.38527344 -1.08789062 9.26367188 C-1.09111328 8.22919922 -1.09433594 7.19472656 -1.09765625 6.12890625 C-1.10289307 5.17056885 -1.10812988 4.21223145 -1.11352539 3.22485352 C-1 1 -1 1 0 0 Z ",
    fill: "#071D2C",
    transform: "translate(381,462)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 9.24 1 18.48 1 28 C0.67 28 0.34 28 0 28 C-0.16820551 26.06263299 -0.33451095 24.12510094 -0.5 22.1875 C-0.5928125 21.10855469 -0.685625 20.02960937 -0.78125 18.91796875 C-1 16 -1 16 -1 13 C-1.30688348 10.74813879 -1.63441389 8.50068209 -1.9765625 6.25390625 C-2.00380115 3.63445576 -1.32809246 2.22531523 0 0 Z ",
    fill: "#2A4653",
    transform: "translate(458,549)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.00936388 3.77819335 7.17270443 7.79584593 10.3125 12.3125 C10.76689453 12.95767578 11.22128906 13.60285156 11.68945312 14.26757812 C12.79735952 15.84197142 13.89930525 17.42055646 15 19 C14.34 19.66 13.68 20.32 13 21 C12.59007812 20.44570313 12.18015625 19.89140625 11.7578125 19.3203125 C11.21898437 18.59585937 10.68015625 17.87140625 10.125 17.125 C9.59132813 16.40570313 9.05765625 15.68640625 8.5078125 14.9453125 C7.00126838 12.91747368 7.00126838 12.91747368 5 11 C4.09485188 9.70810677 3.22236371 8.39300968 2.375 7.0625 C1.92898438 6.37285156 1.48296875 5.68320312 1.0234375 4.97265625 C0 3 0 3 0 0 Z ",
    fill: "#19303E",
    transform: "translate(759,452)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.74958984 0.05220703 1.49917969 0.10441406 2.27148438 0.15820312 C4.11887082 0.28763784 5.96574371 0.42436518 7.8125 0.5625 C7.4825 1.8825 7.1525 3.2025 6.8125 4.5625 C6.4825 4.2325 6.1525 3.9025 5.8125 3.5625 C3.46262738 3.32722227 1.10693961 3.14863583 -1.25 3 C-2.54035156 2.91621094 -3.83070313 2.83242188 -5.16015625 2.74609375 C-6.65869141 2.65521484 -6.65869141 2.65521484 -8.1875 2.5625 C-8.8475 3.8825 -9.5075 5.2025 -10.1875 6.5625 C-10.5175 4.5825 -10.8475 2.6025 -11.1875 0.5625 C-7.35939179 -0.71353607 -3.95274893 -0.30033987 0 0 Z ",
    fill: "#1B2F3C",
    transform: "translate(852.1875,404.4375)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.52920984 8.20275254 0.22980957 15.23188883 -5.25 21.625 C-6.11625 22.305625 -6.11625 22.305625 -7 23 C-6.55999803 19.58998476 -5.51361977 16.83025796 -4.0625 13.75 C-1.99092272 9.26786006 -0.87064187 4.84580936 0 0 Z ",
    fill: "#1E3543",
    transform: "translate(440,566)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.38405168 3.04119788 -1.2856382 5.04072937 -3 7 C-3.66 7 -4.32 7 -5 7 C-5.268125 7.598125 -5.53625 8.19625 -5.8125 8.8125 C-7.03585242 11.06604393 -7.97960332 12.42858036 -10 14 C-12.6875 14.6875 -12.6875 14.6875 -15 15 C-13.71937515 13.2925002 -12.38232443 11.62626404 -11 10 C-10.34 10 -9.68 10 -9 10 C-8.67 9.01 -8.34 8.02 -8 7 C-6.15234375 5.17578125 -6.15234375 5.17578125 -3.9375 3.3125 C-2.83728516 2.37857422 -2.83728516 2.37857422 -1.71484375 1.42578125 C-1.14894531 0.95527344 -0.58304688 0.48476563 0 0 Z ",
    fill: "#24404F",
    transform: "translate(233,459)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.03126794 4.05140978 2.5810988 6.58052202 0.9765625 10.5 C-1.53912003 14.65287275 -2.9680993 16.66769299 -7.6875 18.1875 C-11 18 -11 18 -14 16 C-12.7625 15.7525 -11.525 15.505 -10.25 15.25 C-6.40321865 14.24412784 -4.24454407 13.45314473 -2 10 C-1.09611656 6.69615019 -0.49137704 3.38791539 0 0 Z ",
    fill: "#203C4B",
    transform: "translate(491,429)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.02708567 1.60407328 2.04643483 3.2082785 2.0625 4.8125 C2.07410156 5.70582031 2.08570313 6.59914063 2.09765625 7.51953125 C2 10 2 10 1 13 C0.77202438 15.73289293 0.58331813 18.45042204 0.4375 21.1875 C0.39431641 21.93708984 0.35113281 22.68667969 0.30664062 23.45898438 C0.20077315 25.30578375 0.0999024 27.15286834 0 29 C-0.33 29 -0.66 29 -1 29 C-1.02937438 25.66668561 -1.04692334 22.33340517 -1.0625 19 C-1.07087891 18.06542969 -1.07925781 17.13085938 -1.08789062 16.16796875 C-1.10708892 10.67725599 -0.8134193 5.43133519 0 0 Z ",
    fill: "#355160",
    transform: "translate(163,495)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.12981031 4.24467604 -1.30097529 6.31209191 -2.625 8.4375 C-2.96917969 9.02337891 -3.31335938 9.60925781 -3.66796875 10.21289062 C-5.96034981 13.93906722 -8.07092229 16.07681986 -12 18 C-10.41184838 14.65777047 -8.54017193 11.56349757 -6.5625 8.4375 C-5.66724609 7.01244141 -5.66724609 7.01244141 -4.75390625 5.55859375 C-3.29292196 3.42731377 -1.90254133 1.72799625 0 0 Z ",
    fill: "#1B3443",
    transform: "translate(289,497)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C4.89223503 2.46396693 4.89223503 2.46396693 8.125 2.625 C9.76855469 2.73714844 9.76855469 2.73714844 11.4453125 2.8515625 C12.28835938 2.90054687 13.13140625 2.94953125 14 3 C14 2.01 14 1.02 14 0 C14.66 0 15.32 0 16 0 C16.33 1.65 16.66 3.3 17 5 C11.72 5 6.44 5 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#263D4A",
    transform: "translate(874,483)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.65 0.66 3.3 1 5 C0.01 4.34 -0.98 3.68 -2 3 C-2.99 3.495 -2.99 3.495 -4 4 C-4.99 4 -5.98 4 -7 4 C-9.01151741 4.63106429 -11.01363702 5.29373761 -13 6 C-9.06759014 0.63762292 -6.83642575 -1.66291437 0 0 Z ",
    fill: "#1C3F51",
    transform: "translate(268,442)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.15178302 9.05638678 1.69037426 17.97582223 1 27 C0.67 27 0.34 27 0 27 C-0.19766544 23.43798805 -0.38133629 19.87538633 -0.5625 16.3125 C-0.61857422 15.30509766 -0.67464844 14.29769531 -0.73242188 13.25976562 C-0.78076172 12.28330078 -0.82910156 11.30683594 -0.87890625 10.30078125 C-0.9260376 9.40528564 -0.97316895 8.50979004 -1.02172852 7.5871582 C-0.99942695 4.93176823 -0.60392668 2.58041401 0 0 Z ",
    fill: "#122B39",
    transform: "translate(690,407)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0.33 13.2 0.66 20 1 C19.67 1.66 19.34 2.32 19 3 C16.77110504 3.05428973 14.54182529 3.09292338 12.3125 3.125 C10.45044922 3.15980469 10.45044922 3.15980469 8.55078125 3.1953125 C5.18762143 3.01032021 3.0014413 2.45767895 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#152F3F",
    transform: "translate(393,586)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.75360177 9.91392686 2.75360177 9.91392686 -0.125 14.0625 C-4.90943396 17.28679245 -4.90943396 17.28679245 -8 18 C-10.3125 17.125 -10.3125 17.125 -12 16 C-10.9275 15.7525 -9.855 15.505 -8.75 15.25 C-4.02567 13.69533864 -4.02567 13.69533864 -1 10 C-0.38265375 6.67260833 -0.12896658 3.37892443 0 0 Z ",
    fill: "#294555",
    transform: "translate(588,542)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0.66 13.2 1.32 20 2 C17.3381996 4.6618004 15.95750737 4.29866602 12.25 4.3125 C7.27997339 4.24679051 4.12011479 3.74674319 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#142D3D",
    transform: "translate(480,585)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-5.94 2 -11.88 2 -18 2 C-18.33 1.34 -18.66 0.68 -19 0 C-12.43507888 -0.78441153 -6.53162622 -1.10914408 0 0 Z ",
    fill: "#081F2E",
    transform: "translate(480,446)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.66 2 2.32 2 3 2 C4.65 6.62 6.3 11.24 8 16 C7.34 16.66 6.68 17.32 6 18 C5.66226563 17.07316406 5.32453125 16.14632813 4.9765625 15.19140625 C4.30753906 13.39509766 4.30753906 13.39509766 3.625 11.5625 C3.18414063 10.36753906 2.74328125 9.17257812 2.2890625 7.94140625 C1.32914764 4.89803102 1.32914764 4.89803102 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#26404D",
    transform: "translate(852,426)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.18135474 6.48349807 2.11322974 12.86214507 2.0625 19.4375 C2.05798828 20.55060547 2.05347656 21.66371094 2.04882812 22.81054688 C2.03711193 25.54042101 2.02070699 28.27018174 2 31 C1.67 31 1.34 31 1 31 C0.97494385 30.44538086 0.9498877 29.89076172 0.92407227 29.31933594 C0.80772073 26.79601157 0.68517246 24.27302464 0.5625 21.75 C0.52318359 20.87730469 0.48386719 20.00460937 0.44335938 19.10546875 C0.40146484 18.26113281 0.35957031 17.41679688 0.31640625 16.546875 C0.27974854 15.77182617 0.24309082 14.99677734 0.20532227 14.19824219 C0.00387827 12.04152194 -0.46490999 10.09392661 -1 8 C-0.84682979 5.29234605 -0.4031119 2.68741267 0 0 Z ",
    fill: "#3E5C6A",
    transform: "translate(178,580)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C31.34 1.32 30.68 2.64 30 4 C29.67 3.34 29.34 2.68 29 2 C19.43 1.67 9.86 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#4C6F7F",
    transform: "translate(836,468)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 9.57 1.66 19.14 2 29 C1.01 29.33 0.02 29.66 -1 30 C-0.67 20.1 -0.34 10.2 0 0 Z ",
    fill: "#324F5C",
    transform: "translate(302,422)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C2.95901454 2.88617347 4.9172338 2.75858875 6.875 2.625 C8.51082031 2.52058594 8.51082031 2.52058594 10.1796875 2.4140625 C13.13046474 2.26746509 13.13046474 2.26746509 15 0 C15 1.65 15 3.3 15 5 C10.38 5 5.76 5 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#082130",
    transform: "translate(815,482)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.12245047 2.08163365 -6.07034881 3.32575613 -9.5625 4.6875 C-10.71878906 5.14511719 -11.87507812 5.60273438 -13.06640625 6.07421875 C-16 7 -16 7 -18 6 C-16.50251406 3.00502811 -14.28663353 2.60492085 -11.25 1.3125 C-10.20328125 0.85488281 -9.1565625 0.39726562 -8.078125 -0.07421875 C-4.83770747 -1.04881133 -3.19234395 -0.97543843 0 0 Z ",
    fill: "#25404F",
    transform: "translate(260,412)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.6 1 13.2 1 20 C1.66 20.33 2.32 20.66 3 21 C2.67 22.65 2.34 24.3 2 26 C1.01 25.67 0.02 25.34 -1 25 C-0.67 16.75 -0.34 8.5 0 0 Z ",
    fill: "#3A5866",
    transform: "translate(176,508)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.46373047 0.16628906 1.46373047 0.16628906 2.95703125 0.3359375 C3.69308594 0.43132812 4.42914063 0.52671875 5.1875 0.625 C-0.39221839 3.46097257 -4.58727369 3.72875377 -10.8125 3.625 C-10.8125 2.965 -10.8125 2.305 -10.8125 1.625 C-6.91531829 -0.24165742 -4.27165815 -0.51465761 0 0 Z ",
    fill: "#1B3241",
    transform: "translate(280.8125,392.375)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1.8125 2 1.8125 4 4 C4 4.99 4 5.98 4 7 C-1.28 7 -6.56 7 -12 7 C-11.67 6.34 -11.34 5.68 -11 5 C-7.04 5 -3.08 5 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#0D1F2C",
    transform: "translate(750,593)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.97066406 0.09023438 1.94132813 0.18046875 2.94140625 0.2734375 C5.4375 0.625 5.4375 0.625 7.4375 1.625 C6.4375 2.625 6.4375 2.625 2.62109375 2.72265625 C1.03903318 2.71598089 -0.54301159 2.70401875 -2.125 2.6875 C-2.93130859 2.68298828 -3.73761719 2.67847656 -4.56835938 2.67382812 C-6.56643756 2.66200518 -8.56447783 2.64406914 -10.5625 2.625 C-7.20297316 -0.73452684 -4.47944411 -0.44138331 0 0 Z ",
    fill: "#2D4651",
    transform: "translate(850.5625,453.375)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.05429959 1.74965358 2.09292823 3.49979787 2.125 5.25 C2.14820313 6.22453125 2.17140625 7.1990625 2.1953125 8.203125 C1.99862781 11.0196498 1.44568916 12.60949036 0 15 C-1.47193312 12.05613377 -0.84936173 9.62609964 -0.5625 6.375 C-0.46066406 5.18648438 -0.35882812 3.99796875 -0.25390625 2.7734375 C-0.17011719 1.85820312 -0.08632813 0.94296875 0 0 Z ",
    fill: "#152B38",
    transform: "translate(782,408)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-2.10170656 1.53067341 -4.20647598 2.04922857 -6.3125 2.5625 C-7.48425781 2.85253906 -8.65601563 3.14257812 -9.86328125 3.44140625 C-13 4 -13 4 -16 3 C-16 2.34 -16 1.68 -16 1 C-10.10106757 -0.79074734 -6.06820868 -1.08360869 0 0 Z ",
    fill: "#264251",
    transform: "translate(280,407)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C3 2.66 3 3.32 3 4 C3.556875 4.268125 4.11375 4.53625 4.6875 4.8125 C7.21225334 6.10899496 9.63714484 7.42476323 12 9 C12 9.66 12 10.32 12 11 C6.73487298 9.74639833 3.14505244 7.38299861 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#162D3B",
    transform: "translate(565,475)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.71284028 2.64936048 0.42012981 4.29439047 -0.875 5.9375 C-1.95394531 7.31228516 -1.95394531 7.31228516 -3.0546875 8.71484375 C-5 11 -5 11 -7 12 C-6.38801624 8.56049636 -5.07941153 6.48435515 -2.9375 3.75 C-2.38964844 3.04359375 -1.84179688 2.3371875 -1.27734375 1.609375 C-0.85582031 1.07828125 -0.43429687 0.5471875 0 0 Z ",
    fill: "#162C39",
    transform: "translate(402,416)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.55643705 6.20988129 -0.91532502 10.60540561 -4 16 C-5.35304209 11.94087374 -4.15216503 10.22850409 -2.5625 6.3125 C-2.08941406 5.13300781 -1.61632812 3.95351563 -1.12890625 2.73828125 C-0.75636719 1.83464844 -0.38382813 0.93101562 0 0 Z ",
    fill: "#162C3A",
    transform: "translate(707,554)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 5.94 1 11.88 1 18 C0.67 18 0.34 18 0 18 C-1.59138085 13.82262526 -2.21278058 10.46839215 -2 6 C-1.67 6 -1.34 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z ",
    fill: "#233B48",
    transform: "translate(546,536)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C14.67 0.66 14.34 1.32 14 2 C8.78217876 3.52716719 5.06434289 2.48437636 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#182F3F",
    transform: "translate(584,474)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.1744176 1.09462676 3.98914157 1.98177335 5.75 4.9375 C7 8 7 8 7 11 C5.68 10.67 4.36 10.34 3 10 C2.814375 8.63875 2.814375 8.63875 2.625 7.25 C2.07890323 4.41029677 1.42736197 2.47409409 0 0 Z ",
    fill: "#19303E",
    transform: "translate(614,414)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.65 0.66 3.3 1 5 C0.01 4.67 -0.98 4.34 -2 4 C-2 3.34 -2 2.68 -2 2 C-3.98 2.66 -5.96 3.32 -8 4 C-8.66 3.34 -9.32 2.68 -10 2 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#274250",
    transform: "translate(576,462)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.34914492 2.34914492 2.73140357 3.95679446 3.625 7.125 C3.88539063 8.03507813 4.14578125 8.94515625 4.4140625 9.8828125 C4.70410156 10.93082031 4.70410156 10.93082031 5 12 C4.34 12.66 3.68 13.32 3 14 C-0.44419134 4.58997722 -0.44419134 4.58997722 0 0 Z ",
    fill: "#1B3342",
    transform: "translate(169,553)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.60938465 2.41407698 2.65490738 4.34044437 3.6875 7 C3.95949219 7.680625 4.23148438 8.36125 4.51171875 9.0625 C5 11 5 11 4 14 C-0.59225513 4.58997722 -0.59225513 4.58997722 0 0 Z ",
    fill: "#172D3B",
    transform: "translate(716,538)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-2.16952847 5.26008643 -5.39937989 8.22237877 -9 11 C-8.49904971 6.65843079 -5.89476995 4.10153923 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#112635",
    transform: "translate(220,473)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1 3 -1 3 -3.6875 4.6875 C-7.08981286 6.03558623 -9.38327271 6.25833766 -13 6 C-10.65890118 4.43926745 -8.43666597 3.13626133 -5.9375 1.875 C-5.24527344 1.52179687 -4.55304688 1.16859375 -3.83984375 0.8046875 C-2 0 -2 0 0 0 Z ",
    fill: "#152B37",
    transform: "translate(514,594)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.1446875 1.175625 1.1446875 1.175625 2.3125 2.375 C4.90891805 5.07257717 4.90891805 5.07257717 8 7 C7.67 7.66 7.34 8.32 7 9 C5.1875 8.8125 5.1875 8.8125 3 8 C0.85802506 5.09303401 0 3.64478912 0 0 Z ",
    fill: "#1D3543",
    transform: "translate(421,538)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.81248985 3.6249797 2.31888915 5.37259584 2.625 9.25 C2.69976562 10.14203125 2.77453125 11.0340625 2.8515625 11.953125 C2.90054688 12.62859375 2.94953125 13.3040625 3 14 C2.34 13.01 1.68 12.02 1 11 C0.01 10.34 -0.98 9.68 -2 9 C-1.34 9 -0.68 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#152A37",
    transform: "translate(165,534)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10.33 0.66 10.66 1.32 11 2 C6.91556885 3.53166168 3.20544343 2.63081652 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#2A4351",
    transform: "translate(399,517)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.54955729 4.10958767 -1.51110752 7.43258745 -4 11 C-5 8 -5 8 -4.07421875 5.95703125 C-3.61660156 5.24933594 -3.15898437 4.54164063 -2.6875 3.8125 C-2.23761719 3.09707031 -1.78773438 2.38164062 -1.32421875 1.64453125 C-0.88722656 1.10183594 -0.45023437 0.55914062 0 0 Z ",
    fill: "#223A49",
    transform: "translate(298,506)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.433125 0.474375 0.86625 0.94875 1.3125 1.4375 C3.02309613 3.23686957 3.02309613 3.23686957 6 4 C5.67 4.66 5.34 5.32 5 6 C2.67843403 6.40729228 0.3431213 6.74438677 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#204255",
    transform: "translate(426,478)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.25740623 3.33524782 -2.2805761 5.18705073 -5 7 C-6.32 6.67 -7.64 6.34 -9 6 C-6.03 4.02 -3.06 2.04 0 0 Z ",
    fill: "#213B49",
    transform: "translate(252,446)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-2 5 -5 8 -8 11 C-7.49268371 6.60325886 -4.88085945 4.16191891 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#112A3A",
    transform: "translate(392,431)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C1.36 2.98 -1.28 4.96 -4 7 C-4.66 6.67 -5.32 6.34 -6 6 C-4 4 -2 2 0 0 Z ",
    fill: "#182E3C",
    transform: "translate(383,522)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 4 2 4 2.875 6.0625 C4.22423539 8.38618318 5.78294615 9.5219641 8 11 C4.62537285 10.45276317 2.91765 9.9451 0 8 C-0.40843923 5.28796348 -0.13336867 2.7562858 0 0 Z ",
    fill: "#213B4A",
    transform: "translate(578,424)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C1.67 3.66 1.34 4.32 1 5 C-2.3 4.67 -5.6 4.34 -9 4 C-7 2 -7 2 -3.875 1.875 C-2.92625 1.91625 -1.9775 1.9575 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#274352",
    transform: "translate(725,566)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.50223584 4.20626034 -4.28550034 5.73900021 -8 8 C-8 7.01 -8 6.02 -8 5 C-2.65116279 0 -2.65116279 0 0 0 Z ",
    fill: "#1D3645",
    transform: "translate(280,531)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.9765625 4.1640625 1.9765625 4.1640625 1.625 6.625 C1.51414063 7.44226563 1.40328125 8.25953125 1.2890625 9.1015625 C1.19367188 9.72804688 1.09828125 10.35453125 1 11 C0.34 10.34 -0.32 9.68 -1 9 C-0.9765625 6.8359375 -0.9765625 6.8359375 -0.625 4.375 C-0.51414063 3.55773437 -0.40328125 2.74046875 -0.2890625 1.8984375 C-0.19367188 1.27195312 -0.09828125 0.64546875 0 0 Z ",
    fill: "#213B49",
    transform: "translate(176,497)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.27286682 2.7819368 4.96427697 6.27954067 7 10 C6.01 10 5.02 10 4 10 C0 3.375 0 3.375 0 0 Z ",
    fill: "#192F3D",
    transform: "translate(481,466)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.34 3.64 0.68 6.28 0 9 C-1.5625 7.25 -1.5625 7.25 -3 5 C-2.8125 2.8125 -2.8125 2.8125 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#254251",
    transform: "translate(563,465)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.33773709 3.64116773 3.97864902 7.28607242 5 12 C1.61053312 9.74035542 1.14663284 8.79270862 0 5 C-0.125 2.1875 -0.125 2.1875 0 0 Z ",
    fill: "#142A38",
    transform: "translate(859,442)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.40114397 0.50298788 6.71195019 2.08772731 10 5 C9.67 5.99 9.34 6.98 9 8 C6.95880212 6.38405168 4.95927063 4.7143618 3 3 C3 2.34 3 1.68 3 1 C2.01 0.67 1.02 0.34 0 0 Z ",
    fill: "#183040",
    transform: "translate(606,443)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95696581 1.23924145 7.11658466 2.78577758 10 7 C6.00118212 6.38479725 3.19641774 4.39731331 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#213B4A",
    transform: "translate(492,408)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C0.535 3.97 0.535 3.97 -3 7 C-3.66 6.67 -4.32 6.34 -5 6 C-3.35 4.02 -1.7 2.04 0 0 Z ",
    fill: "#132B3A",
    transform: "translate(204,561)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.3418344 4.02550319 -3.4227573 4.88285636 -7 7 C-7.66 7 -8.32 7 -9 7 C-7.68534669 3.05604006 -4.38536841 0 0 0 Z ",
    fill: "#1C3442",
    transform: "translate(270,539)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.825 0.309375 1.65 0.61875 2.5 0.9375 C6.39126155 2.11877583 9.96166953 2.58224168 14 3 C14 3.33 14 3.66 14 4 C10.04 4 6.08 4 2 4 C1.34 2.68 0.68 1.36 0 0 Z ",
    fill: "#173444",
    transform: "translate(545,517)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.95929119 2.75520215 5.03681826 5.46627288 7 9 C6.01 9 5.02 9 4 9 C0 3.85714286 0 3.85714286 0 0 Z ",
    fill: "#19303E",
    transform: "translate(391,455)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.6875 1.6875 0.6875 1.6875 1 4 C-0.25 6.6875 -0.25 6.6875 -2 9 C-2.99 9.33 -3.98 9.66 -5 10 C-3.66511872 6.40608886 -2.03977277 3.24509304 0 0 Z ",
    fill: "#223A47",
    transform: "translate(179,453)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64752004 2.57784846 4.94432065 4.91648098 7 8 C6.67 8.99 6.34 9.98 6 11 C4.99126984 9.73608512 3.99328178 8.46359117 3 7.1875 C2.443125 6.47980469 1.88625 5.77210938 1.3125 5.04296875 C0 3 0 3 0 0 Z ",
    fill: "#132632",
    transform: "translate(759,452)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.3125 2.6875 1.3125 2.6875 1 6 C-1.5 8.875 -1.5 8.875 -4 11 C-3.21681311 7.08406554 -1.60820142 3.63593365 0 0 Z ",
    fill: "#122937",
    transform: "translate(425,571)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.33523252 1.38009621 5.18607951 2.84950652 7 6 C6.67 6.99 6.34 7.98 6 9 C4.99406757 7.8803014 3.9954151 6.7540588 3 5.625 C2.443125 4.99851562 1.88625 4.37203125 1.3125 3.7265625 C0 2 0 2 0 0 Z ",
    fill: "#142B3A",
    transform: "translate(400,446)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.01 5.33 -0.98 5.66 -2 6 C-2 6.66 -2 7.32 -2 8 C-2.99 7.67 -3.98 7.34 -5 7 C-4.19152271 5.83054208 -3.37810888 4.66449539 -2.5625 3.5 C-2.11003906 2.8503125 -1.65757812 2.200625 -1.19140625 1.53125 C-0.79824219 1.0259375 -0.40507812 0.520625 0 0 Z ",
    fill: "#203A49",
    transform: "translate(185,444)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.8141763 3.37503669 -0.27573689 5.64722731 -3 8 C-3.66 7.67 -4.32 7.34 -5 7 C-4.21654285 5.82780457 -3.42297164 4.66236332 -2.625 3.5 C-2.18414062 2.8503125 -1.74328125 2.200625 -1.2890625 1.53125 C-0.65097656 0.77328125 -0.65097656 0.77328125 0 0 Z ",
    fill: "#162F3D",
    transform: "translate(508,578)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C4.04169485 2.90548882 5 4.40142046 5 8 C4.34 8 3.68 8 3 8 C0.95830515 5.09451118 0 3.59857954 0 0 Z ",
    fill: "#193240",
    transform: "translate(474,576)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 3.96 1.66 7.92 2 12 C1.01 11.67 0.02 11.34 -1 11 C-0.67 7.37 -0.34 3.74 0 0 Z ",
    fill: "#041927",
    transform: "translate(406,558)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.35595828 0.59927826 5.37801226 1.84622436 8 4 C7.67 5.32 7.34 6.64 7 8 C6.401875 7.236875 5.80375 6.47375 5.1875 5.6875 C3.53040668 3.6516425 1.89702326 1.8021721 0 0 Z ",
    fill: "#162D3C",
    transform: "translate(592,524)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 3 2 3 1.75 6.0625 C1 9 1 9 -1 11 C-0.67 7.37 -0.34 3.74 0 0 Z ",
    fill: "#112837",
    transform: "translate(605,460)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.96404505 2.80804268 5.44499019 5.18315774 7 9 C6.01 9 5.02 9 4 9 C0 2.25 0 2.25 0 0 Z ",
    fill: "#162833",
    transform: "translate(744,431)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-0.465 3.97 -0.465 3.97 -4 7 C-4 4 -4 4 -2 1.8125 C-1.34 1.214375 -0.68 0.61625 0 0 Z ",
    fill: "#203644",
    transform: "translate(193,435)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C-1.455 3.485 -1.455 3.485 -6 5 C-5 2 -5 2 -2.625 0.6875 C-1.75875 0.460625 -0.8925 0.23375 0 0 Z ",
    fill: "#24404F",
    transform: "translate(434,541)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0326802 2.78823655 1.04509293 3.8677274 0.0625 6.75 C-0.288125 7.4925 -0.63875 8.235 -1 9 C-1.66 9 -2.32 9 -3 9 C-2.44271087 5.65626525 -1.64826111 2.96687001 0 0 Z ",
    fill: "#1F3644",
    transform: "translate(201,519)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.90931332 3.77545388 0.0916909 6.47043472 -3 9 C-2.44271087 5.65626525 -1.64826111 2.96687001 0 0 Z ",
    fill: "#152C3A",
    transform: "translate(197,500)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.875 4.75 4.875 4.75 6 7 C3.13275314 6.42655063 2.1385485 6.1385485 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#223C4B",
    transform: "translate(418,468)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-1.25 4.5625 -1.25 4.5625 -4 6 C-5.32 5.67 -6.64 5.34 -8 5 C-4.04 2.525 -4.04 2.525 0 0 Z ",
    fill: "#172E3B",
    transform: "translate(499,449)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.67542976 0.28604898 3.34385343 0.61781233 5 1 C5.33 2.65 5.66 4.3 6 6 C5.5875 5.54625 5.175 5.0925 4.75 4.625 C2.93591905 2.94049626 1.24714373 2.00734029 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#2D4652",
    transform: "translate(263,441)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.465 1.485 -3.465 1.485 -7 3 C-7 1.68 -7 0.36 -7 -1 C-3.51418144 -2.2020064 -3.32007656 -2.21338437 0 0 Z ",
    fill: "#2B4653",
    transform: "translate(614,428)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.34058637 2.12780579 3.70700306 4.11562221 5 7 C4.01 7 3.02 7 2 7 C0 4 0 4 0 0 Z ",
    fill: "#182C3A",
    transform: "translate(461,582)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C-0.4375 6.25 -0.4375 6.25 -2 8 C-2.99 7.67 -3.98 7.34 -5 7 C-3.35 4.69 -1.7 2.38 0 0 Z ",
    fill: "#223A4A",
    transform: "translate(205,488)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.5 2.3125 2.5 2.3125 5 5 C5 5.99 5 6.98 5 8 C2.5 5.6875 2.5 5.6875 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#193140",
    transform: "translate(398,465)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.38405168 3.04119788 -0.2856382 5.04072937 -2 7 C-2.66 7 -3.32 7 -4 7 C-2.79618552 4.50638429 -1.54571278 2.31856917 0 0 Z ",
    fill: "#1C3542",
    transform: "translate(403,435)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.67 2.99 1.34 3.98 1 5 C0.34 3.68 -0.32 2.36 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#496977",
    transform: "translate(169,562)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#456675",
    transform: "translate(571,574)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#476675",
    transform: "translate(636,536)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 3 -0.32 3 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#456675",
    transform: "translate(695,597)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.01 1.67 0.02 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#446675",
    transform: "translate(565,574)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#4C6A76",
    transform: "translate(177,611)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#476675",
    transform: "translate(636,561)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#486976",
    transform: "translate(162,537)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#4B6A79",
    transform: "translate(160,513)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#446776",
    transform: "translate(817,467)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#426576",
    transform: "translate(586,453)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#4B6D7B",
    transform: "translate(576,403)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#496879",
    transform: "translate(368,585)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#406170",
    transform: "translate(497,584)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466576",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426475",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#456574",
    transform: "translate(405,554)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#436676",
    transform: "translate(211,553)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6D7B",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A79",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#456676",
    transform: "translate(571,485)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426475",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#436575",
    transform: "translate(400,473)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#436473",
    transform: "translate(754,450)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#436672",
    transform: "translate(857,448)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#46697A",
    transform: "translate(244,448)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#406173",
    transform: "translate(568,445)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#446876",
    transform: "translate(560,431)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F6272",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#416475",
    transform: "translate(480,421)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486B7B",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4D6E7C",
    transform: "translate(599,401)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496976",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B7A",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486775",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6878",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496977",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466674",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496876",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#416574",
    transform: "translate(398,584)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466977",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476776",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446577",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416275",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456878",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466A7A",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6977",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406072",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#436574",
    transform: "translate(420,542)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476778",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#446777",
    transform: "translate(677,535)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#476677",
    transform: "translate(668,535)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6979",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436675",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466674",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486877",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466776",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#496978",
    transform: "translate(457,517)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E6E7C",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#436576",
    transform: "translate(408,487)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456676",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436573",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466878",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6A79",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6A79",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436574",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#416371",
    transform: "translate(859,470)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#436573",
    transform: "translate(851,470)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#426473",
    transform: "translate(846,470)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446676",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#426573",
    transform: "translate(601,461)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A78",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476A7A",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476877",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446876",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6B7B",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4A6D7B",
    transform: "translate(193,432)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446777",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416273",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476A78",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6C7A",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6977",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#446676",
    transform: "translate(294,407)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4C6C7A",
    transform: "translate(428,402)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#595C5B",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58737D",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56707E",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#506A77",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#526E7A",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6A76",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F6C7A",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476573",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496877",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496976",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6877",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6A77",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496B7A",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6877",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6B7A",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476C7D",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6A79",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476979",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476575",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496775",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466879",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476978",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B79",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486576",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466775",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486676",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416472",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E6171",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476877",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476777",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436373",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446475",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416473",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426273",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436374",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456874",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466676",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486977",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456674",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456777",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486B78",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486978",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456673",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6978",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6979",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466879",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466C7A",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41606D",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466777",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466674",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486977",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456678",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436377",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446677",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6C7B",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446573",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406473",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6B7A",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426574",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456575",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436675",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6878",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416374",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A79",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48697A",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C606F",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B7D",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A78",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426576",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6D7C",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6C7A",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6C7D",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466779",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A79",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476876",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496776",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456976",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436777",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C5B6C",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406274",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E6B7B",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406371",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476777",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466877",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6C7C",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A79",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436675",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436372",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456475",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486877",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E6E7A",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40616C",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476878",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466774",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B5F72",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446474",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406272",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466675",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6977",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6C78",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446373",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456775",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F5F71",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446575",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456575",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416272",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A78",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496B78",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436375",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446475",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426576",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466777",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436676",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466578",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476676",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476A78",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426777",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446578",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436475",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456675",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466877",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426675",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446474",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486875",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6877",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496876",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466674",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466572",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476B7B",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406070",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476979",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6A77",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6C7C",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6B76",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476776",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A687B",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466877",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49687A",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6B7A",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6979",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A79",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A7A",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B7A",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A78",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6E7C",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6E7C",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456678",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6F7B",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E6E7C",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#526C79",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#405E68",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426270",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476977",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456678",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426474",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6E7C",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456574",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486877",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45626F",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486777",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456678",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456575",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476675",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48697A",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456676",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496978",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#405F6D",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F6E7D",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456979",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F6975",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E626D",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436776",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456879",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446675",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6B7B",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446577",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6B7A",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476874",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446779",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426375",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456675",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476676",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426774",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446675",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476B7B",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D5F6F",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C6070",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466977",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A7B",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446676",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6C7B",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436574",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F5E71",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486977",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416173",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436677",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426676",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446776",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406574",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A7B",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456676",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436776",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496977",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6B78",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F6473",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436476",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476776",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6D7D",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46697B",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B79",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6C7A",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436373",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416373",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406271",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426374",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496877",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49697A",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436173",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406373",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456676",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426675",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486877",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416272",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476676",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466879",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426576",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446676",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41616E",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426674",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486C7B",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F6474",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466778",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486979",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446777",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436372",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476879",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476777",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446573",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456675",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446877",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446775",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426374",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446776",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49687A",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436376",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#416675",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466877",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456576",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F6174",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466877",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446675",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496777",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446977",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456777",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#415D6E",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436372",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436775",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476878",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486977",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456775",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446777",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436472",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436778",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6E7D",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436470",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E5D70",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466878",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476677",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476877",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476B79",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436572",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446678",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436575",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446676",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47687B",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436573",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#436677",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426373",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F5E6F",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466678",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496A7B",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6C78",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#406472",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476977",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466778",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476778",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456879",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426272",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476878",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476977",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6B7A",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446777",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6C7B",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#426574",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#456A7A",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6E7E",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466778",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446676",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466879",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446878",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486879",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E6E7C",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6D7E",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#496B7C",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486877",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486A78",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#486877",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6E7B",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#446675",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#476978",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466878",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466779",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A6C7B",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466773",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B6D7A",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B7C",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#466676",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E6E7D",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#506B76",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B79",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6A77",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6B79",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D6F7C",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E707F",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F6F7D",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E707F",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E707D",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D707D",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F717E",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E707D",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C6C7B",
    transform: "translate(0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2bf9465245a7a79c9a8550d3fc4893de.svg";
export { ForwardRef as ReactComponent };